import { MaterialQuestion } from './informatika9Data.ts';

export const INFORMATIKA_IX_QUESTIONS: MaterialQuestion[] = [
  // ==========================================
  // BAB I: BERPIKIR KOMPUTASIONAL DALAM ANALISIS DATA
  // Sub-Bab 0: Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)
  // ==========================================
  {
    id: "b1-q0-1",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Metode berpikir logis dan sistematis untuk memahami permasalahan serta merancang solusi terstruktur yang dapat dijalankan oleh manusia maupun komputer dinamakan...",
    options: ["Pemrograman Tekstual", "Berpikir Komputasional (Computational Thinking)", "Data Mining", "Kecerdasan Buatan (Artificial Intelligence)"],
    correctAnswerIndex: 1,
    explanation: "Berpikir Komputasional adalah landasan berpikir logis untuk memecahkan masalah dengan merancang solusi terstruktur."
  },
  {
    id: "b1-q0-2",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Empat pilar utama yang menjadi batu penyangga (Cornerstone) dalam Berpikir Komputasional meliputi...",
    options: [
      "Abstraksi, Dekomposisi, Pengenalan Pola, dan Algoritma",
      "Input, Process, Output, dan Storage",
      "Hardware, Software, Brainware, dan Netware",
      "Sorting, Searching, Filtering, dan Cleaning"
    ],
    correctAnswerIndex: 0,
    explanation: "4 Cornerstone penyangga utama Berpikir Komputasional adalah Abstraksi, Dekomposisi, Pengenalan Pola, dan Penyusunan Algoritma."
  },
  {
    id: "b1-q0-3",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Proses menyaring detail yang tidak relevan dan berfokus hanya pada informasi penting dari suatu permasalahan kompleks dinamakan...",
    options: ["Dekomposisi", "Pengenalan Pola", "Abstraksi", "Algoritma"],
    correctAnswerIndex: 2,
    explanation: "Abstraksi menyaring aspek yang tidak penting agar kita dapat fokus pada informasi esensial dalam menyelesaikan masalah."
  },
  {
    id: "b1-q0-4",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Saat menganalisis konsumsi listrik sekolah, seorang siswa hanya mencatat jumlah siswa dan total daya listrik per kelas, lalu mengabaikan warna cat kelas dan jenis lantai. Siswa tersebut sedang menerapkan pilar...",
    options: ["Abstraksi", "Dekomposisi", "Pengenalan Pola", "Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Mengabaikan informasi yang tidak relevan (seperti warna cat tembok) dan fokus pada data utama merupakan bentuk Abstraksi."
  },
  {
    id: "b1-q0-5",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Proses memecah permasalahan besar dan rumit menjadi beberapa bagian kecil yang lebih sederhana agar lebih mudah diselesaikan dinamakan...",
    options: ["Dekomposisi", "Abstraksi", "Pengenalan Pola", "Enkripsi"],
    correctAnswerIndex: 0,
    explanation: "Dekomposisi membagi masalah kompleks menjadi sub-masalah kecil yang mandiri dan lebih mudah ditangani."
  },
  {
    id: "b1-q0-6",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Proyek analisis data sekolah dipecah menjadi tahapan: (a) mengumpulkan data, (b) membersihkan data, (c) membuat tabel, (d) membuat grafik, dan (e) menarik kesimpulan. Langkah pembagian ini merupakan penerapan...",
    options: ["Pengenalan Pola", "Abstraksi", "Dekomposisi", "Algoritma"],
    correctAnswerIndex: 2,
    explanation: "Membagi alur analisis data besar menjadi tahapan-tahapan kecil yang fokus adalah bentuk Dekomposisi."
  },
  {
    id: "b1-q0-7",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Proses mencari kesamaan, tren, atau keteraturan dalam berbagai masalah untuk membantu menentukan solusi yang tepat dinamakan...",
    options: ["Pengenalan Pola (Pattern Recognition)", "Abstraksi", "Dekomposisi", "Penyusunan Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Pengenalan Pola mengenali kecenderungan atau kesamaan dari data/masalah terdahulu untuk diterapkan pada kondisi baru."
  },
  {
    id: "b1-q0-8",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Hasil pengolahan grafik menunjukkan bahwa bertambahnya jumlah siswa di kelas selalu berbanding lurus dengan peningkatan konsumsi listrik. Proses menemukan keteraturan hubungan ini memanfaatkan...",
    options: ["Pengenalan Pola", "Dekomposisi", "Abstraksi", "Koding"],
    correctAnswerIndex: 0,
    explanation: "Menemukan pola hubungan korelasi berbanding lurus antara variabel merupakan contoh Pengenalan Pola."
  },
  {
    id: "b1-q0-9",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Proses menyusun langkah-langkah logis, sistematis, dan terstruktur untuk menyelesaikan suatu permasalahan secara konsisten disebut...",
    options: ["Penyusunan Algoritma", "Abstraksi", "Dekomposisi", "Pengenalan Pola"],
    correctAnswerIndex: 0,
    explanation: "Algoritma memberikan urutan instruksi presisi agar solusi dapat dijalankan berulang kali dengan hasil yang konsisten."
  },
  {
    id: "b1-q0-10",
    chapterId: 1,
    sectionCode: "0",
    sectionTitle: "Konsep Berpikir Komputasional & 4 Batu Penyangga (Cornerstone)",
    text: "Mengapa komputer memerlukan konsep Berpikir Komputasional sebelum dapat membantu menyelesaikan masalah manusia?",
    options: [
      "Karena komputer hanya dapat menjalankan instruksi yang jelas, logis, dan terstruktur",
      "Karena komputer bisa berpikir sendiri tanpa diberi instruksi",
      "Karena komputer tidak membutuhkan data sama sekali",
      "Karena komputer secara otomatis memperbaiki kesalahan logika manusia"
    ],
    correctAnswerIndex: 0,
    explanation: "Komputer membutuhkan solusi terstruktur yang dirancang secara logis agar instruksi dapat dieksekusi dengan tepat."
  },

  {
    id: "b1-q1",
    chapterId: 1,
    sectionCode: "A",
    sectionTitle: "Struktur Data Tree",
    text: "Struktur data hierarkis berbentuk pohon yang terdiri dari node (simpul) dan edge (sisi) tanpa sirkulasi terhubung dinamakan...",
    options: ["Graph", "Tree", "Stack", "Queue"],
    correctAnswerIndex: 1,
    explanation: "Tree (Pohon) adalah struktur data hierarkis berpuncak pada satu simpul utama (root) tanpa adanya siklus."
  },
  {
    id: "b1-q2",
    chapterId: 1,
    sectionCode: "A",
    sectionTitle: "Struktur Data Tree",
    text: "Simpul paling atas pada struktur data Tree yang tidak memiliki parent (orang tua) disebut...",
    options: ["Leaf (Daun)", "Root (Akar)", "Child (Anak)", "Branch (Dahan)"],
    correctAnswerIndex: 1,
    explanation: "Root merupakan elemen atau node pertama paling atas dalam struktur data Tree."
  },
  {
    id: "b1-q3",
    chapterId: 1,
    sectionCode: "A",
    sectionTitle: "Struktur Data Tree",
    text: "Simpul pada struktur data Tree yang tidak memiliki anak (child) sama sekali dinamakan...",
    options: ["Root node", "Internal node", "Leaf node (Daun)", "Parent node"],
    correctAnswerIndex: 2,
    explanation: "Leaf node (daun) adalah simpul paling ujung dari rantai hierarki Tree yang tidak memiliki anak lagi."
  },
  {
    id: "b1-q4",
    chapterId: 1,
    sectionCode: "A",
    sectionTitle: "Struktur Data Tree",
    text: "Penerapan struktur data Tree paling tepat pada sistem komputer sehari-hari adalah...",
    options: [
      "Jaringan jalan raya antar kota",
      "Struktur direktori/folder penyimpanan file dalam sistem operasi",
      "Jalur transmisi sinyal Wi-Fi",
      "Daftar antrean cetak printer"
    ],
    correctAnswerIndex: 1,
    explanation: "Folder dan subfolder pada sistem operasi tersusun secara hierarkis menggunakan konsep struktur data Tree."
  },
  {
    id: "b1-q5",
    chapterId: 1,
    sectionCode: "A",
    sectionTitle: "Struktur Data Tree",
    text: "Dalam Binary Tree (Pohon Biner), setiap simpul parent maksimal hanya dapat memiliki anak sebanyak...",
    options: ["1 anak", "2 anak", "3 anak", "Tidak terbatas"],
    correctAnswerIndex: 1,
    explanation: "Binary Tree membatasi bahwa tiap simpul induk maksimal memiliki 2 simpul anak (left child & right child)."
  },
  {
    id: "b1-q6",
    chapterId: 1,
    sectionCode: "A",
    sectionTitle: "Struktur Data Tree",
    text: "Tinggi (height) dari sebuah struktur data Tree ditentukan berdasarkan...",
    options: [
      "Jumlah total seluruh node",
      "Jumlah cabang yang sejajar",
      "Panjang jalur terpanjang dari Root menuju Leaf",
      "Jumlah daun paling bawah"
    ],
    correctAnswerIndex: 2,
    explanation: "Tinggi tree diukur dari level teratas (root) menuju level terdalam (leaf) pada jalur terpanjang."
  },
  {
    id: "b1-q7",
    chapterId: 1,
    sectionCode: "A",
    sectionTitle: "Struktur Data Tree",
    text: "Manakah pernyataan yang BENAR mengenai struktur data Tree?",
    options: [
      "Setiap node boleh memiliki lebih dari satu parent",
      "Dapat mengandung jalur tertutup (loop/cycle)",
      "Setiap node kecuali root hanya memiliki tepat satu parent",
      "Node tidak memiliki ikatan hubungan hierarki"
    ],
    correctAnswerIndex: 2,
    explanation: "Dalam Tree, setiap node (selain root) hanya terhubung ke satu induk (parent)."
  },
  {
    id: "b1-q8",
    chapterId: 1,
    sectionCode: "B",
    sectionTitle: "Struktur Data Graph",
    text: "Struktur data yang terdiri dari kumpulan simpul (Vertex) yang dihubungkan oleh garis penghubung (Edge) dan dapat membentuk siklus dinamakan...",
    options: ["Tree", "Graph", "Array", "Linked List"],
    correctAnswerIndex: 1,
    explanation: "Graph mengorganisasikan objek (Vertex) beserta relasi atau koneksi antar objek tersebut (Edge)."
  },
  {
    id: "b1-q9",
    chapterId: 1,
    sectionCode: "B",
    sectionTitle: "Struktur Data Graph",
    text: "Graph yang hubungan antar simpulnya memiliki arah tertentu (ditunjukkan dengan tanda panah) disebut...",
    options: ["Undirected Graph", "Directed Graph (Digraph)", "Weighted Graph", "Tree Graph"],
    correctAnswerIndex: 1,
    explanation: "Directed Graph (Digraph) memiliki Edge berarah dari satu simpul asal ke simpul tujuan."
  },
  {
    id: "b1-q10",
    chapterId: 1,
    sectionCode: "B",
    sectionTitle: "Struktur Data Graph",
    text: "Aplikasi navigasi peta digital (seperti Google Maps) memanfaatkan Weighted Graph di mana nilai bobot (weight) pada Edge merepresentasikan...",
    options: [
      "Jumlah pengguna jalan",
      "Jarak atau waktu tempuh antar lokasi",
      "Nama kota tempat tinggal",
      "Jumlah tiang listrik di jalan"
    ],
    correctAnswerIndex: 1,
    explanation: "Bobot (weight) pada edge merepresentasikan biaya, jarak kilometer, atau estimasi waktu tempuh."
  },
  {
    id: "b1-q11",
    chapterId: 1,
    sectionCode: "B",
    sectionTitle: "Struktur Data Graph",
    text: "Perbedaan mendasar antara struktur data Tree dan Graph adalah...",
    options: [
      "Tree dapat memiliki siklus, Graph tidak bisa",
      "Graph dapat memiliki siklus dan banyak root, sedangkan Tree tidak bersiklus dan memiliki 1 root",
      "Tree tidak memiliki hierarki sama sekali",
      "Graph hanya bisa digunakan untuk menyimpan angka"
    ],
    correctAnswerIndex: 1,
    explanation: "Tree adalah bentuk khusus dari Graph terhubung tanpa siklus (acyclic) dengan satu root tunggal."
  },
  {
    id: "b1-q12",
    chapterId: 1,
    sectionCode: "B",
    sectionTitle: "Struktur Data Graph",
    text: "Derajat (Degree) dari sebuah simpul dalam Graph menunjukkan...",
    options: [
      "Suhu penyimpanan simpul tersebut",
      "Jumlah edge (sisi) yang terhubung ke simpul tersebut",
      "Urutan abjad nama simpul",
      "Tinggi posisi simpul dari tanah"
    ],
    correctAnswerIndex: 1,
    explanation: "Degree merepresentasikan berapa banyak garis relasi (edge) yang terhubung pada suatu node/vertex."
  },
  {
    id: "b1-q13",
    chapterId: 1,
    sectionCode: "B",
    sectionTitle: "Struktur Data Graph",
    text: "Algoritma pencarian jalur terpendek (Shortest Path) yang sangat terkenal digunakan pada struktur data Graph adalah...",
    options: ["Algoritma Dijkstra", "Algoritma Bubble Sort", "Algoritma Binary Search", "Algoritma Linear Search"],
    correctAnswerIndex: 0,
    explanation: "Algoritma Dijkstra memecahkan masalah jalur terpendek dari satu simpul sumber ke simpul lain pada Weighted Graph."
  },
  {
    id: "b1-q14",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Menentukan Tujuan",
    text: "Langkah pertama dalam proses analisis data terstruktur adalah...",
    options: [
      "Langsung membuat grafik warna-warni",
      "Menentukan tujuan analisis dan pertanyaan penelitian yang ingin dijawab",
      "Menghapus seluruh baris data",
      "Membeli komputer baru"
    ],
    correctAnswerIndex: 1,
    explanation: "Menentukan tujuan memberikan arah yang jelas agar proses pengumpulan dan analisis data menjadi efisien."
  },
  {
    id: "b1-q15",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Pengumpulan Data",
    text: "Proses mengumpulkan data primer langsung dari responden menggunakan instrumen pertanyaan terstruktur disebut...",
    options: ["Observasi", "Survei / Kuesioner", "Data Scraping", "Eksperimen Laboratorium"],
    correctAnswerIndex: 1,
    explanation: "Survei atau kuesioner adalah metode pengumpulan data primer langsung dari responden."
  },
  {
    id: "b1-q16",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Cleaning",
    text: "Kegiatan mendeteksi dan memperbaiki nilai yang hilang (missing value), data ganda (duplicate), serta format yang tidak konsisten dinamakan...",
    options: ["Data Mining", "Data Cleaning (Pembersihan Data)", "Data Encryption", "Data Backup"],
    correctAnswerIndex: 1,
    explanation: "Data cleaning memastikan data bersih, akurat, dan siap diolah tanpa bias akibat kesalahan data mentah."
  },
  {
    id: "b1-q17",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Cleaning",
    text: "Data mentah memiliki entri umur siswa '-15' dan '999'. Tindakan yang tepat saat proses Data Cleaning adalah...",
    options: [
      "Membiarkan angka tersebut",
      "Menghapus atau mengoreksi data yang bernilai tidak logis (outlier/anomali)",
      "Mengalikan seluruh umur dengan angka 2",
      "Mengubah seluruh data menjadi kata 'Error'"
    ],
    correctAnswerIndex: 1,
    explanation: "Nilai tidak masuk akal harus dikoreksi atau dibuang agar tidak merusak perhitungan statistik."
  },
  {
    id: "b1-q18",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Eksplorasi",
    text: "Tujuan utama dari tahap Eksplorasi Data (Exploratory Data Analysis) adalah...",
    options: [
      "Menjual data ke pihak ketiga",
      "Mengenali pola dasar, sebaran data, nilai rata-rata, dan hubungan antar variabel",
      "Membuat animasi video 3D",
      "Mengunci file spreadsheet dengan kata sandi"
    ],
    correctAnswerIndex: 1,
    explanation: "Eksplorasi data bertujuan memahami karakteristik dasar dan hipotesis awal dari dataset."
  },
  {
    id: "b1-q19",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Eksplorasi",
    text: "Ukuran pemusatan data yang menunjukkan nilai yang paling sering muncul dalam sebuah himpunan data dinamakan...",
    options: ["Mean (Rata-rata)", "Median (Nilai Tengah)", "Modus", "Simpangan Baku"],
    correctAnswerIndex: 2,
    explanation: "Modus adalah nilai atau kategori data dengan frekuensi kemunculan terbanyak."
  },
  {
    id: "b1-q20",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Visualisasi",
    text: "Jenis grafik yang paling sesuai untuk menampilkan persentase proporsi atau kontribusi bagian dari keseluruhan (100%) adalah...",
    options: ["Line Chart (Grafik Garis)", "Pie Chart (Grafik Lingkaran)", "Scatter Plot", "Histogram"],
    correctAnswerIndex: 1,
    explanation: "Pie Chart dirancang untuk memvisualisasikan komposisi persentase bagian terhadap total."
  },
  {
    id: "b1-q21",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Visualisasi",
    text: "Jika kita ingin melihat tren perubahan suhu udara dari hari ke hari selama satu bulan, jenis grafik yang paling efektif adalah...",
    options: ["Pie Chart", "Line Chart (Grafik Garis)", "Bar Chart (Grafik Batang)", "Donut Chart"],
    correctAnswerIndex: 1,
    explanation: "Line Chart sangat tepat memperlihatkan kontinyuitas dan tren perubahan data terhadap waktu (time series)."
  },
  {
    id: "b1-q22",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Visualisasi",
    text: "Perangkat visualisasi data yang menggabungkan beberapa grafik dan indikator kinerja utama dalam satu tampilan ringkas dinamakan...",
    options: ["Database", "Dashboard", "Spreadsheet", "Slide Presentation"],
    correctAnswerIndex: 1,
    explanation: "Dashboard menyajikan ringkasan visual dari berbagai metrik dan indikator analisis secara real-time."
  },
  {
    id: "b1-q23",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Visualisasi",
    text: "Teknik memadukan data kuantitatif dengan narasi cerita kontekstual agar hasil analisis mudah dipahami oleh audiens disebut...",
    options: ["Data Storytelling", "Data Mining", "Data Hacking", "Data Scraping"],
    correctAnswerIndex: 0,
    explanation: "Data storytelling menyelaraskan fakta angka, visualisasi grafik, dan alur cerita wawasan action-oriented."
  },
  {
    id: "b1-q24",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Format",
    text: "Format file teks sederhana bersistem pemisah tanda koma yang umum digunakan untuk pertukaran data terstruktur adalah...",
    options: [".pdf", ".csv (Comma Separated Values)", ".mp3", ".docx"],
    correctAnswerIndex: 1,
    explanation: "CSV adalah standar format file terstruktur berbasis teks polos berpemisah koma atau titik koma."
  },
  {
    id: "b1-q25",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Pivot Table",
    text: "Fitur pada aplikasi pengolah angka (Excel/Google Sheets) yang memungkinkan pengguna meringkas dan memutarbalikkan baris-kolom data secara cepat adalah...",
    options: ["Mail Merge", "Pivot Table", "Format Painter", "Spell Check"],
    correctAnswerIndex: 1,
    explanation: "Pivot Table sangat ampuh melakukan manipulasi agregasi dan pengelompokan data dalam hitungan detik."
  },
  {
    id: "b1-q26",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Filtering",
    text: "Proses menyaring baris data dalam spreadsheet agar hanya menampilkan data dengan kriteria tertentu (misal: Nilai > 80) disebut...",
    options: ["Sorting", "Filtering", "Merging", "Wrapping"],
    correctAnswerIndex: 1,
    explanation: "Filtering menyembunyikan sementara data yang tidak memenuhi kriteria penyeleksian."
  },
  {
    id: "b1-q27",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Sorting",
    text: "Mengurutkan data dari nilai terkecil ke nilai terbesar (A-Z atau 1-100) dinamakan pengurutan...",
    options: ["Ascending", "Descending", "Random", "Reverse"],
    correctAnswerIndex: 0,
    explanation: "Ascending mengurutkan data secara menaik (dari kecil ke besar / A sampai Z)."
  },
  {
    id: "b1-q28",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Etika",
    text: "Dalam memublikasikan hasil analisis data masyarakat, prinsip etika yang WAJIB diterapkan terkait kerahasiaan identitas individu adalah...",
    options: ["Eksploitasi data", "Anonimisasi Data (Data Anonymization)", "Monetisasi paksa", "Publikasi alamat rumah"],
    correctAnswerIndex: 1,
    explanation: "Anonimisasi data menghilangkan atribut pribadi sensitif agar privasi individu tetap terlindungi."
  },
  {
    id: "b1-q29",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Outlier",
    text: "Data ekstrem yang nilainya menyimpang sangat jauh dari mayoritas data lainnya dalam suatu kelompok disebut...",
    options: ["Outlier (Pencilan)", "Median", "Mode", "Cluster"],
    correctAnswerIndex: 0,
    explanation: "Outlier adalah nilai pencilan yang jauh di luar pola distribusi umum sampel data."
  },
  {
    id: "b1-q30",
    chapterId: 1,
    sectionCode: "C",
    sectionTitle: "Analisis Data - Kesimpulan",
    text: "Tahap akhir setelah visualisasi data selesai dibuat dalam proyek analisis data adalah...",
    options: [
      "Menghapus seluruh file",
      "Penarikan kesimpulan dan rekomendasi aksi berdasarkan bukti data",
      "Mengulang survei dari awal",
      "Mematikan server internet"
    ],
    correctAnswerIndex: 1,
    explanation: "Tujuan akhir analisis data adalah menghasilkan rekomendasi aksi nyata dan pemahaman baru yang bernilai."
  },

  // ==========================================
  // BAB I: SUB-BAB D: STUDI KASUS PENYELESAIAN MASALAH DENGAN 4 PILAR BERPIKIR KOMPUTASIONAL (20 SOAL)
  // ==========================================
  {
    id: "b1-qd-1",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Pada program Bank Sampah Sekolah, tim OSIS membagi sistem menjadi: (1) Pengumpulan sampah per kelas, (2) Pemilahan jenis material, (3) Penimbangan & kalkulasi tabungan, dan (4) Distribusi ke pengepul daur ulang. Tahap pemecahan ini merupakan penerapan pilar...",
    options: ["Abstraksi", "Dekomposisi", "Pengenalan Pola", "Penyusunan Algoritma"],
    correctAnswerIndex: 1,
    explanation: "Memecah sistem pengelolaan sampah yang rumit menjadi beberapa bagian tugas kecil yang mandiri adalah wujud nyata pilar Dekomposisi."
  },
  {
    id: "b1-qd-2",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Saat menimbang sampah botol plastik di Bank Sampah, petugas hanya mencatat total berat timbangan (kg) dan kategori plastik PET, tanpa memedulikan merek air mineral ataupun warna tutup botol. Tindakan ini mencerminkan pilar...",
    options: ["Abstraksi", "Dekomposisi", "Pengenalan Pola", "Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Abstraksi menyaring detail yang tidak relevan (merek/warna tutup botol) dan berfokus pada informasi penting yang dibutuhkan (jenis plastik dan berat timbangan)."
  },
  {
    id: "b1-qd-3",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Setelah mengamati data selama 3 bulan, koordinator kebersihan menemukan bahwa volume sampah botol plastik selalu melonjak drastis hingga 75% setiap hari Jumat dan saat jam istirahat kedua. Penemuan keteraturan tren ini merupakan penerapan pilar...",
    options: ["Penyusunan Algoritma", "Abstraksi", "Pengenalan Pola (Pattern Recognition)", "Dekomposisi"],
    correctAnswerIndex: 2,
    explanation: "Mengidentifikasi keteraturan atau tren kenaikan volume sampah pada waktu tertentu adalah bentuk Pengenalan Pola."
  },
  {
    id: "b1-qd-4",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Instruksi kerja petugas bank sampah disusun: 'Siswa setor sampah -> Petugas pilah jenis -> Timbang berat -> Hitung saldo (Berat x Rp 3.000) -> Catat ke buku tabungan digital -> Simpan di karung terpisah'. Urutan langkah terstruktur ini menerapkan pilar...",
    options: ["Dekomposisi", "Pengenalan Pola", "Abstraksi", "Penyusunan Algoritma"],
    correctAnswerIndex: 3,
    explanation: "Menyusun langkah-langkah logis, berurutan, dan terstruktur untuk memproses tabungan sampah secara konsisten adalah penerapan Algoritma."
  },
  {
    id: "b1-qd-5",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Seorang kurir ekspedisi membagi area pengantaran 60 paket menjadi 4 zona wilayah (Utara, Selatan, Barat, Timur) agar rute pengiriman terfokus dan efisien. Tindakan kurir tersebut menerapkan pilar...",
    options: ["Dekomposisi", "Abstraksi", "Pengenalan Pola", "Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Membagi wilayah pengantaran paket yang luas menjadi kelompok zona-zona kecil merupakan contoh Dekomposisi masalah."
  },
  {
    id: "b1-qd-6",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Dalam aplikasi navigasi peta digital (GPS), sistem menghitung rute tercepat dengan memproses titik koordinat lokasi, jarak jalan, dan kepadatan lalu lintas, tanpa memproses warna pagar atau bentuk genteng rumah penduduk di sepanjang jalan. Penerapan pilar ini disebut...",
    options: ["Algoritma", "Dekomposisi", "Abstraksi", "Debugging"],
    correctAnswerIndex: 2,
    explanation: "Menyaring informasi fisik yang tidak berpengaruh pada perjalanan (warna cat/bentuk genteng) dan hanya memakai data esensial (jarak, koordinat, waktu) adalah Abstraksi."
  },
  {
    id: "b1-qd-7",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Aplikasi transportasi online mengenali bahwa ruas jalan protokol selalu mengalami kepadatan lalu lintas parah pada pukul 06.30 - 08.00 WIB setiap hari kerja. Sistem memanfaatkan data riwayat tersebut untuk mengarahkan pengguna ke jalur alternatif. Hal ini menerapkan prinsip...",
    options: ["Abstraksi", "Pengenalan Pola", "Dekomposisi", "Enkripsi"],
    correctAnswerIndex: 1,
    explanation: "Mendeteksi jam-jam sibuk berulang yang terjadi secara konsisten setiap hari kerja merupakan wujud dari Pengenalan Pola."
  },
  {
    id: "b1-qd-8",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Dalam merancang sistem otomasi rapor siswa, alur pengolahan dipecah menjadi: (1) perhitungan nilai formatif per TP, (2) pembobotan nilai sumatif, (3) rekapitulasi presensi, dan (4) konversi ke predikat narasi. Pemecahan ini adalah penerapan pilar...",
    options: ["Dekomposisi", "Abstraksi", "Pengenalan Pola", "Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Memecah modul rapor besar menjadi sub-tugas perhitungan mandiri yang terstruktur adalah penerapan Dekomposisi."
  },
  {
    id: "b1-qd-9",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Seorang guru mengidentifikasi bahwa rumus kalkulasi nilai akhir: Nilai_Akhir = (40% formatif + 60% sumatif) memiliki format yang sama persis untuk seluruh 32 siswa di kelas. Guru tersebut memanfaatkan pilar...",
    options: ["Pengenalan Pola", "Dekomposisi", "Abstraksi", "Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Melihat bahwa semua siswa memiliki pola struktur formula kalkulasi yang seragam merupakan Pengenalan Pola."
  },
  {
    id: "b1-qd-10",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Ketika komputer laboratorium menyala namun layar monitor gelap dan terdengar bunyi '1 Beep Panjang + 2 Beep Pendek' dari motherboard, teknisi langsung mengetahui kerusakan ada pada VGA/kartu grafis berdasarkan pengalaman kasus sebelumnya. Teknisi tersebut menerapkan...",
    options: ["Abstraksi", "Pengenalan Pola", "Dekomposisi", "Algoritma"],
    correctAnswerIndex: 1,
    explanation: "Mencocokkan kode bunyi sinyal beep motherboard dengan jenis kerusakan komponen secara spesifik merupakan bentuk Pengenalan Pola."
  },
  {
    id: "b1-qd-11",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Saat melakukan perbaikan (troubleshooting) komputer yang mati total, teknisi melakukan pemeriksaan secara berurutan: (1) Cek kabel power -> (2) Cek sakelar PSU -> (3) Tes motherboard -> (4) Bersihkan pin RAM. Alur kerja bertahap ini menerapkan...",
    options: ["Algoritma", "Abstraksi", "Dekomposisi", "Enkapsulasi"],
    correctAnswerIndex: 0,
    explanation: "Urutan langkah-langkah logis dan sistematis dalam mendiagnosa kerusakan secara bertahap adalah Algoritma."
  },
  {
    id: "b1-qd-12",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Dalam mendiagnosa kerusakan PC, teknisi mengabaikan stiker hiasan di casing luar dan warna lampu LED dekorasi, melainkan hanya fokus pada nilai voltase voltmeter dan kode galat (error code) di layar. Hal ini mencerminkan pilar...",
    options: ["Dekomposisi", "Abstraksi", "Pengenalan Pola", "Algoritma"],
    correctAnswerIndex: 1,
    explanation: "Mengabaikan tampilan kosmetik casing dan memusatkan fokus pada parameter fungsional listrik/error code adalah penerapan Abstraksi."
  },
  {
    id: "b1-qd-13",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Sistem antrean loket pelayanan publik memproses warga berdasarkan urutan nomor tiket: 'Warga yang datang dan mengambil tiket lebih dahulu, akan dilayani lebih dahulu'. Logika sistem antrean ini menerapkan struktur data dan algoritma...",
    options: ["Stack (LIFO)", "Queue (FIFO - First In First Out)", "Tree Non-linear", "Binary Search"],
    correctAnswerIndex: 1,
    explanation: "Struktur Queue menerapkan prinsip FIFO (First In First Out), di mana data atau orang yang masuk pertama akan dilayani pertama kali."
  },
  {
    id: "b1-qd-14",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Pada sistem irigasi pintar (Smart Farming), pengembang membagi sistem menjadi 3 bagian: (1) Subsistem Sensor Tanah & Hujan, (2) Unit Mikrokontroler Pengolah Logika, dan (3) Subsistem Aktuator Pompa Air. Pembagian arsitektur ini menerapkan pilar...",
    options: ["Dekomposisi", "Abstraksi", "Pengenalan Pola", "Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Membagi sistem IoT pertanian menjadi 3 blok subsistem fungsional yang terpisah adalah penerapan Dekomposisi."
  },
  {
    id: "b1-qd-15",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Pada sistem penyiraman otomatis perkebunan terdapat aturan instruksi: 'JIKA kelembaban tanah < 35% DAN sensor hujan = FALSE, MAKA aktifkan pompa selama 10 menit'. Aturan instruksi logika ini merupakan perwujudan pilar...",
    options: ["Algoritma", "Abstraksi", "Pengenalan Pola", "Dekomposisi"],
    correctAnswerIndex: 0,
    explanation: "Kondisi logika IF-THEN terstruktur yang menentukan tindakan otomatis mesin adalah bentuk Algoritma."
  },
  {
    id: "b1-qd-16",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Saat merancang sistem deteksi email penipuan (phishing), analis keamanan siber menemukan kesamaan ciri pada 100 email jebakan: menggunakan sapaan generik ('Kepada Pelanggan'), tautan mengarah ke domain palsu, dan meminta verifikasi OTP secara mendesak. Analis tersebut menerapkan pilar...",
    options: ["Pengenalan Pola", "Dekomposisi", "Abstraksi", "Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Menemukan ciri-ciri kesamaan karakteristik dari berbagai contoh email penipuan adalah penerapan Pengenalan Pola."
  },
  {
    id: "b1-qd-17",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Sistem kamera tilang elektronik (ETLE) di jalan raya memotret mobil yang melanggar. Sistem mengabaikan stiker variasi di kaca mobil dan penumpang di dalam, lalu memfokuskan pemrosesan citra OCR hanya pada karakter pelat nomor polisi. Pilar BK yang digunakan adalah...",
    options: ["Abstraksi", "Dekomposisi", "Pengenalan Pola", "Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Menyaring objek visual yang tidak relevan dan memusatkan deteksi hanya pada data pelat nomor adalah Abstraksi."
  },
  {
    id: "b1-qd-18",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Dalam proyek perencanaan Pentas Seni Sekolah, panitia memecah tugas menjadi divisi Acara, Perlengkapan, Konsumsi, dan Dana, kemudian menyusun jadwal kerja (timeline) bertahap dari H-30 hingga Hari-H. Dua pilar utama yang dipadukan adalah...",
    options: [
      "Dekomposisi dan Algoritma",
      "Abstraksi dan Enkripsi",
      "Pengenalan Pola dan Sorting",
      "Data Mining dan Filtering"
    ],
    correctAnswerIndex: 0,
    explanation: "Membagi divisi kerja kepanitiaan adalah Dekomposisi, sedangkan menyusun urutan timeline jadwal kerja dari awal hingga akhir adalah Algoritma."
  },
  {
    id: "b1-qd-19",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Aplikasi streaming musik menganalisis lagu-lagu yang sering diputar pengguna (bertempo lambat dengan dominasi piano akustik) untuk kemudian otomatis menyajikan daftar rekomendasi lagu serupa yang disukai. Aplikasi ini bekerja atas dasar pilar...",
    options: ["Pengenalan Pola", "Dekomposisi", "Abstraksi", "Algoritma"],
    correctAnswerIndex: 0,
    explanation: "Mengenali kesamaan karakteristik genre, tempo, dan instrumen dari riwayat pemutaran musik pengguna adalah Pengenalan Pola."
  },
  {
    id: "b1-qd-20",
    chapterId: 1,
    sectionCode: "D",
    sectionTitle: "Studi Kasus 4 Pilar Berpikir Komputasional",
    text: "Manakah kesimpulan yang PALING TEPAT mengenai integrasi 4 pilar Berpikir Komputasional dalam memecahkan masalah kehidupan sehari-hari?",
    options: [
      "Keempat pilar harus selalu digunakan secara terpisah dan tidak boleh digabungkan",
      "Berpikir Komputasional hanya dapat diterapkan jika kita memiliki komputer supercanggih",
      "Keempat pilar saling melengkapi untuk menyederhanakan masalah kompleks menjadi solusi yang terstruktur, efisien, dan dapat diotomatisasi",
      "Hanya pilar Algoritma yang berguna, sedangkan pilar lainnya tidak dibutuhkan"
    ],
    correctAnswerIndex: 2,
    explanation: "Keempat pilar (Dekomposisi, Pengenalan Pola, Abstraksi, dan Algoritma) bersinergi untuk mengubah permasalahan kompleks menjadi solusi yang jelas, terstruktur, efisien, dan dapat dijalankan manusia maupun komputer."
  },

  // ==========================================
  // BAB II: BERPIKIR KOMPUTASIONAL DALAM ALGORITMA DAN PEMROGRAMAN (30 SOAL)
  // ==========================================
  {
    id: "b2-q1",
    chapterId: 2,
    sectionCode: "A",
    sectionTitle: "Modularisasi Program",
    text: "Teknik memecah program besar menjadi bagian-bagian fungsi kecil yang mandiri dan terfokus dinamakan...",
    options: ["Decomposisi / Modularisasi Program", "Linearisasi", "Kompresi", "Enkapsulasi"],
    correctAnswerIndex: 0,
    explanation: "Modularisasi membagi kode menjadi blok modul/fungsi terpisah agar rapi, mudah dibaca, dan dikelola."
  },
  {
    id: "b2-q2",
    chapterId: 2,
    sectionCode: "A",
    sectionTitle: "Modularisasi Program",
    text: "Keuntungan utama penerapan modularisasi dalam pembuatan program adalah...",
    options: [
      "Membuat ukuran file gambar menjadi kecil",
      "Kode dapat digunakan kembali (reusable) dan mempermudah pelacakan error (debugging)",
      "Menghilangkan kebutuhan memori RAM",
      "Mempercepat koneksi Wi-Fi"
    ],
    correctAnswerIndex: 1,
    explanation: "Modul fungsi yang telah dibuat dapat dipanggil berulang kali di tempat berbeda tanpa menulis ulang kode."
  },
  {
    id: "b2-q3",
    chapterId: 2,
    sectionCode: "A",
    sectionTitle: "Modularisasi - Scratch Block",
    text: "Pada lingkungan pemrograman visual Scratch, fitur untuk membuat blok fungsi buatan sendiri berada pada menu...",
    options: ["My Blocks (Blok Saya)", "Control", "Sensing", "Variables"],
    correctAnswerIndex: 0,
    explanation: "'My Blocks' memungkinkan pengguna Scratch mendefinisikan kustom prosedur/fungsi baru."
  },
  {
    id: "b2-q4",
    chapterId: 2,
    sectionCode: "A",
    sectionTitle: "Library Pemrograman",
    text: "Kumpulan modul, fungsi, dan subrutin siap pakai yang telah disediakan untuk mempercepat pengembangan software disebut...",
    options: ["Database", "Library (Pustaka Kode)", "Compiler", "Text Editor"],
    correctAnswerIndex: 1,
    explanation: "Library menyediakan fungsi instan yang siap diimpor untuk tugas spesifik (misal: grafik, matematika)."
  },
  {
    id: "b2-q5",
    chapterId: 2,
    sectionCode: "A",
    sectionTitle: "Penggunaan Library",
    text: "Saat kita memerlukan kalkulasi fungsi matematika kompleks (seperti akar kuadrat dan trigonometri) di Python, kita mengimpor library...",
    options: ["import random", "import math", "import time", "import os"],
    correctAnswerIndex: 1,
    explanation: "Library `math` pada Python menyediakan berbagai fungsi dan konstanta matematika standar."
  },
  {
    id: "b2-q6",
    chapterId: 2,
    sectionCode: "A",
    sectionTitle: "Penggunaan Library",
    text: "Kata kunci yang digunakan dalam pemrograman Python untuk memasukkan library eksternal ke dalam kode kita adalah...",
    options: ["include", "import", "using", "require"],
    correctAnswerIndex: 1,
    explanation: "Sintaks `import nama_library` digunakan pada Python untuk memuat pustaka kode."
  },
  {
    id: "b2-q7",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Visual Blok vs Tekstual",
    text: "Pemrograman berbasis visual blok (seperti Scratch/Blockly) sangat cocok bagi pemula karena...",
    options: [
      "Dapat berjalan di sistem tanpa listrik",
      "Mencegah kesalahan sintaks (syntax error) dengan menyusun blok puzzle yang presisi",
      "Menghasilkan aplikasi paling cepat di dunia",
      "Tidak menggunakan logika sama sekali"
    ],
    correctAnswerIndex: 1,
    explanation: "Blok drag-and-drop mencegah typo titik koma atau kurung kurawal yang biasa terjadi di kode teks."
  },
  {
    id: "b2-q8",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Visual Blok vs Tekstual",
    text: "Keterbatasan utama pemrograman visual blok dibandingkan pemrograman tekstual adalah...",
    options: [
      "Tampilannya menarik",
      "Kurang efisien dan terbatas untuk membangun sistem software skala besar dan kompleks",
      "Tidak dapat dijalankan di laptop",
      "Hanya bisa digunakan oleh orang dewasa"
    ],
    correctAnswerIndex: 1,
    explanation: "Bahasa tekstual memiliki fleksibilitas tinggi dan performa optimal untuk aplikasi komersial kompleks."
  },
  {
    id: "b2-q9",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Transisi ke Tekstual",
    text: "Bahasa pemrograman tekstual yang terkenal memiliki sintaks bersih, mudah dibaca mirip bahasa Inggris, dan populer di Kurikulum Merdeka adalah...",
    options: ["Assembly", "Python", "Machine Code", "C++"],
    correctAnswerIndex: 1,
    explanation: "Python merupakan bahasa pemrograman tingkat tinggi yang sangat ramah pembelajar pemula."
  },
  {
    id: "b2-q10",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Sintaks Python",
    text: "Perintah pada Python yang berfungsi untuk menampilkan teks atau nilai variabel ke layar monitor adalah...",
    options: ["input()", "print()", "show()", "write()"],
    correctAnswerIndex: 1,
    explanation: "`print()` digunakan untuk mencetak pesan atau keluaran data ke konsol layar."
  },
  {
    id: "b2-q11",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Sintaks Python",
    text: "Fungsi bawaan Python yang digunakan untuk menerima masukan ketikan dari pengguna melalui keyboard adalah...",
    options: ["read()", "input()", "get()", "scan()"],
    correctAnswerIndex: 1,
    explanation: "`input()` mengambil perintah ketikan pengguna sebagai tipe data string."
  },
  {
    id: "b2-q12",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Tipe Data Python",
    text: "Tipe data Python yang digunakan untuk menyimpan angka bulat (seperti 10, -5, 2024) dinamakan...",
    options: ["float", "int (integer)", "str (string)", "bool (boolean)"],
    correctAnswerIndex: 1,
    explanation: "`int` mewakili bilangan bulat tanpa koma/desimal."
  },
  {
    id: "b2-q13",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Tipe Data Python",
    text: "Tipe data Python yang digunakan untuk menyimpan angka desimal/pecahan (seperti 3.14 atau 87.5) adalah...",
    options: ["int", "float", "char", "boolean"],
    correctAnswerIndex: 1,
    explanation: "`float` merepresentasikan bilangan real bercakupan desimal."
  },
  {
    id: "b2-q14",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Tipe Data Python",
    text: "Tipe data logika yang hanya bernilai `True` atau `False` disebut...",
    options: ["string", "boolean", "integer", "double"],
    correctAnswerIndex: 1,
    explanation: "Boolean menyimpan kebenaran kondisi logika: True (benar) atau False (salah)."
  },
  {
    id: "b2-q15",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Kondisional Python",
    text: "Struktur logika percabangan untuk mengeksekusi perintah jika suatu kondisi terpenuhi pada Python menggunakan kata kunci...",
    options: ["for", "if - else", "while", "repeat"],
    correctAnswerIndex: 1,
    explanation: "`if` memeriksa kondisi, dan `else` mengeksekusi blok alternatif jika kondisi salah."
  },
  {
    id: "b2-q16",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Perulangan Python",
    text: "Perulangan yang digunakan jika jumlah iterasi/pengulangan sudah diketahui pasti sejak awal adalah...",
    options: ["while loop", "for loop", "if statement", "try-except"],
    correctAnswerIndex: 1,
    explanation: "`for i in range(n)` mengulang blok kode sebanyak jumlah n kali terhitung."
  },
  {
    id: "b2-q17",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Perulangan Python",
    text: "Perulangan yang terus berjalan SELAMA kondisi tertentu masih bernilai True dinamakan...",
    options: ["for loop", "while loop", "switch-case", "do-while"],
    correctAnswerIndex: 1,
    explanation: "`while` memeriksa syarat logika sebelum mengeksekusi pengulangan berikutnya."
  },
  {
    id: "b2-q18",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Fungsi Python",
    text: "Kata kunci yang digunakan untuk mendefinisikan sebuah fungsi buatan sendiri pada bahasa Python adalah...",
    options: ["function", "def", "procedure", "create"],
    correctAnswerIndex: 1,
    explanation: "Fungsi pada Python didefinisikan dengan perintah `def nama_fungsi():`."
  },
  {
    id: "b2-q19",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Indentasi Python",
    text: "Ciri khas paling penting dalam aturan penulisan kode Python untuk menentukan cakupan blok kode adalah...",
    options: [
      "Menggunakan tanda kurung kurawal {}",
      "Menggunakan Indentasi (spasi/tab di awal baris)",
      "Mengakhiri setiap baris dengan titik koma ;",
      "Menulis dengan huruf kapital semua"
    ],
    correctAnswerIndex: 1,
    explanation: "Python mewajibkan indentasi konsisten untuk menandai cakupan blok fungsi atau loop."
  },
  {
    id: "b2-q20",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Analisis Pseudocode",
    text: "Notasi informal yang menyerupai bahasa pemrograman asli tetapi ditulis dengan bahasa manusia terstruktur dinamakan...",
    options: ["Flowchart", "Pseudocode", "Machine Code", "Binary"],
    correctAnswerIndex: 1,
    explanation: "Pseudocode dirancang agar alur algoritma mudah dipahami manusia sebelum diimplementasikan ke kode."
  },
  {
    id: "b2-q21",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Analisis Pseudocode",
    text: "Perhatikan pseudocode berikut:\n`INPUT nilai`\n`IF nilai >= 75 THEN PRINT 'Tuntas'`\n`ELSE PRINT 'Remidi'`\nJika nilai yang dimasukkan adalah 80, maka outputnya adalah...",
    options: ["Remidi", "Tuntas", "Error", "Tidak tampil apa-apa"],
    correctAnswerIndex: 1,
    explanation: "Karena 80 >= 75 bernilai True, maka pernyataan dalam THEN yaitu 'Tuntas' dieksekusi."
  },
  {
    id: "b2-q22",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Analisis Pseudocode",
    text: "Perhatikan algoritma berikut:\n`x = 5`\n`y = 10`\n`x = x + y`\nBerapakah nilai akhir variabel x?",
    options: ["5", "10", "15", "510"],
    correctAnswerIndex: 2,
    explanation: "Nilai x yang baru adalah hasil penjumlahan 5 + 10 = 15."
  },
  {
    id: "b2-q23",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Operator Aritmatika",
    text: "Symbol operator aritmatika pada Python untuk operasi sisa hasil bagi (Modulus) adalah...",
    options: ["/", "//", "%", "*"],
    correctAnswerIndex: 2,
    explanation: "Operator `%` (Modulus) mengembalikan sisa pembagian dua bilangan."
  },
  {
    id: "b2-q24",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Operator Aritmatika",
    text: "Hasil dari operasi `2 ** 3` pada bahasa Python adalah...",
    options: ["6", "8", "5", "9"],
    correctAnswerIndex: 1,
    explanation: "Operator `**` adalah pemangkatan, sehingga 2 dipangkatkan 3 sama dengan 8."
  },
  {
    id: "b2-q25",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Operator Logika",
    text: "Operator logika yang akan bernilai True HANYA JIKA kedua kondisinya sama-sama bernilai True adalah...",
    options: ["OR", "AND", "NOT", "XOR"],
    correctAnswerIndex: 1,
    explanation: "Operator `AND` mensyaratkan kedua syarat terpenuhi agar bernilai True."
  },
  {
    id: "b2-q26",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Debugging Program",
    text: "Proses melacak, menemukan, dan membetulkan kesalahan (bug) pada program komputer dinamakan...",
    options: ["Compiling", "Debugging", "Refactoring", "Deploying"],
    correctAnswerIndex: 1,
    explanation: "Debugging adalah kegiatan sistematis mendiagnosis dan memperbaiki kesalahan logika/sintaks."
  },
  {
    id: "b2-q27",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Tipe Kesalahan - Syntax Error",
    text: "Kesalahan yang terjadi akibat penulisan aturan tata bahasa kode yang tidak sesuai ketentuan bahasa pemrograman disebut...",
    options: ["Syntax Error", "Logic Error", "Runtime Error", "Hardware Error"],
    correctAnswerIndex: 0,
    explanation: "Syntax Error terjadi jika terdapat typo penulisan kata kunci, kurang tanda kurung, atau spasi tidak tepat."
  },
  {
    id: "b2-q28",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Tipe Kesalahan - Logic Error",
    text: "Program dapat berjalan lancar tanpa error tetapi menghasilkan output kalkulasi yang SALAH. Jenis kesalahan ini adalah...",
    options: ["Syntax Error", "Logic Error (Kesalahan Logika)", "Fatal Error", "Compilation Error"],
    correctAnswerIndex: 1,
    explanation: "Logic Error terjadi karena formula algoritma yang dirancang pemrogram kurang tepat."
  },
  {
    id: "b2-q29",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Komentar Kode",
    text: "Baris tulisan catatan dalam kode Python yang tidak akan dieksekusi oleh komputer diawali dengan simbol...",
    options: ["//", "#", "/*", "--"],
    correctAnswerIndex: 1,
    explanation: "Tanda pagar `#` digunakan untuk menuliskan komentar penjelasan dalam kode Python."
  },
  {
    id: "b2-q30",
    chapterId: 2,
    sectionCode: "B",
    sectionTitle: "Struktur Data List Python",
    text: "Sintaks penulisan struktur data urut (List) pada Python yang menampung banyak data ditandai dengan kurung...",
    options: ["Kurung biasa ()", "Kurung siku []", "Kurung kurawal {}", "Tanda petik ''"],
    correctAnswerIndex: 1,
    explanation: "List pada Python didefinisikan menggunakan kurung siku `[item1, item2, item3]`."
  },

  // ==========================================
  // BAB III: LITERASI DIGITAL UNTUK PRODUKTIVITAS (30 SOAL)
  // ==========================================
  {
    id: "b3-q1",
    chapterId: 3,
    sectionCode: "A",
    sectionTitle: "Pemrosesan Data",
    text: "Siklus pemrosesan data sederhana pada sistem komputer secara berurutan adalah...",
    options: [
      "Output -> Process -> Input",
      "Input -> Process -> Output -> Storage",
      "Storage -> Output -> Input",
      "Process -> Storage -> Output"
    ],
    correctAnswerIndex: 1,
    explanation: "Siklus IPO (Input-Process-Output) diawali pemasukan data, pengolahan, dan penyajian informasi."
  },
  {
    id: "b3-q2",
    chapterId: 3,
    sectionCode: "A",
    sectionTitle: "Pemrosesan Data",
    text: "Masalah utama yang timbul jika data yang dimasukkan ke sistem berstatus 'Garbage In' (data kotor/salah) adalah...",
    options: [
      "Sistem akan otomatis membetulkan",
      "'Garbage Out' (Informasi hasil olahan menjadi tidak akurat/menyesatkan)",
      "Komputer akan meledak",
      "Layar akan berubah menjadi hijau"
    ],
    correctAnswerIndex: 1,
    explanation: "Prinsip 'Garbage In, Garbage Out' menegaskan bahwa kualitas output bergantung pada kualitas input."
  },
  {
    id: "b3-q3",
    chapterId: 3,
    sectionCode: "A",
    sectionTitle: "Dampak Perkakas Digital",
    text: "Penggunaan fitur prapemrosesan dan rumus otomatis pada perkakas digital memberikan dampak positif yaitu...",
    options: [
      "Meningkatkan kesalahan manusia (human error)",
      "Mempercepat efisiensi waktu kerja dan konsistensi hasil olahan data",
      "Memperberat beban kerja staf",
      "Menghilangkan seluruh data lama"
    ],
    correctAnswerIndex: 1,
    explanation: "Perkakas digital mengotomatiskan tugas rutin sehingga meningkatkan ketelitian dan efisiensi."
  },
  {
    id: "b3-q4",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Jenis Data",
    text: "Data yang disajikan dalam bentuk angka, jumlah, atau ukuran kuantitatif yang dapat dihitung dinamakan data...",
    options: ["Kualitatif", "Kuantitatif", "Visual", "Audio"],
    correctAnswerIndex: 1,
    explanation: "Data kuantitatif berbentuk numerik dan dapat diukur secara sistematis."
  },
  {
    id: "b3-q5",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Jenis Data",
    text: "Data berbentuk narasi deskriptif, opini, kata-kata, atau teks tanpa nilai numerik dinamakan data...",
    options: ["Kuantitatif", "Kualitatif", "Biner", "Integer"],
    correctAnswerIndex: 1,
    explanation: "Data kualitatif menggambarkan karakteristik dan makna deskriptif bukan angka."
  },
  {
    id: "b3-q6",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Format Data Gambar",
    text: "Format file gambar kompresi bermutu baik yang mendukung latar belakang transparan adalah...",
    options: [".jpg", ".png", ".bmp", ".txt"],
    correctAnswerIndex: 1,
    explanation: "PNG (Portable Network Graphics) mendukung transparansi alpha channel."
  },
  {
    id: "b3-q7",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Format Data Dokumen",
    text: "Format dokumen standar portabel yang tampilannya konsisten di semua jenis perangkat dan OS tanpa bergeser adalah...",
    options: [".docx", ".pdf", ".txt", ".rtf"],
    correctAnswerIndex: 1,
    explanation: "PDF (Portable Document Format) mengunci tata letak dokumen agar tidak berubah antar perangkat."
  },
  {
    id: "b3-q8",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Perangkat Lunak Produktivitas",
    text: "Aplikasi Microsoft Word, Google Docs, dan LibreOffice Writer termasuk kelompok perangkat lunak...",
    options: ["Pengolah Angka (Spreadsheet)", "Pengolah Kata (Word Processor)", "Pengolah Presentasi", "Pengolah Gambar Vector"],
    correctAnswerIndex: 1,
    explanation: "Word processor dirancang khusus membuat dan menyunting dokumen teks/laporan."
  },
  {
    id: "b3-q9",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Perangkat Lunak Produktivitas",
    text: "Aplikasi Microsoft Excel dan Google Sheets tergolong dalam perangkat lunak...",
    options: ["Pengolah Teks", "Pengolah Angka (Spreadsheet)", "DBMS Relasional", "Desain Grafis"],
    correctAnswerIndex: 1,
    explanation: "Spreadsheet mengolah baris-kolom sel berisi angka, formula, dan fungsi matematis."
  },
  {
    id: "b3-q10",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Perangkat Lunak Produktivitas",
    text: "Aplikasi Microsoft PowerPoint, Google Slides, dan Canva Presentations digunakan untuk...",
    options: [
      "Mengedit rekaman suara",
      "Menyusun slide media presentasi visual interaktif",
      "Membuat program Python",
      "Memindai virus komputer"
    ],
    correctAnswerIndex: 1,
    explanation: "Aplikasi presentasi dirancang menyajikan gagasan visual bermedia slide."
  },
  {
    id: "b3-q11",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Integrasi Konten",
    text: "Metode memasukkan objek grafik Excel ke dalam laporan Word sehingga jika data Excel berubah, grafik di Word OTOMATIS terbarui dinamakan...",
    options: ["Copy Paste Biasa", "Object Linking (OLE)", "Export PDF", "Screen Capture"],
    correctAnswerIndex: 1,
    explanation: "Object Linking menciptakan pranala terhubung aktif antar-dokumen sumber dan tujuan."
  },
  {
    id: "b3-q12",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Integrasi Konten - Mail Merge",
    text: "Fitur Mail Merge dalam pemrosesan dokumen sangat berguna ketika kita ingin membuat...",
    options: [
      "Logo perusahaan baru",
      "Ratusan sertifikat atau surat cetak dengan nama dan alamat penerima yang berbeda dari data tabel",
      "Situs web berita",
      "Lagu musik digital"
    ],
    correctAnswerIndex: 1,
    explanation: "Mail Merge menggabungkan template dokumen dengan database penerima secara masal."
  },
  {
    id: "b3-q13",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Perancangan Konten",
    text: "Tahapan paling awal dalam merancang konten digital edukasi atau promosi adalah...",
    options: [
      "Menentukan target audiens dan tujuan pesan konten",
      "Membeli kamera mahal",
      "Membuat akun media sosial baru",
      "Mengunduh lagu populer"
    ],
    correctAnswerIndex: 0,
    explanation: "Memahami target audiens memastikan gaya bahasa dan visual sesuai harapan calon pembaca."
  },
  {
    id: "b3-q14",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Perancangan Konten - Infografis",
    text: "Kombinasi visual yang memadukan gambar, elemen grafis, dan ringkasan teks ringkas untuk menyampaikan informasi kompleks secara cepat dinamakan...",
    options: ["Vlog", "Infografis", "Podcast", "E-Book"],
    correctAnswerIndex: 1,
    explanation: "Infografis mempermudah pemahaman data melalui sajian visual yang menarik."
  },
  {
    id: "b3-q15",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Perancangan Konten - AI Generatif",
    text: "Teknologi Kecerdasan Artifisial (KA) yang mampu menghasilkan teks, gambar, atau musik baru berdasarkan instruksi (prompt) manusia disebut...",
    options: ["AI Generatif", "Predictive AI", "Expert System", "Automation Macro"],
    correctAnswerIndex: 0,
    explanation: "Generative AI membuat karya konten baru secara otomatis berpatokan pada instruksi prompt."
  },
  {
    id: "b3-q16",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Perancangan Konten - AI Prompting",
    text: "Teks kalimat perintah atau instruksi yang diberikan kepada sistem AI untuk menghasilkan respons karya yang presisi dinamakan...",
    options: ["Script", "Prompt", "Query", "Command Prompt"],
    correctAnswerIndex: 1,
    explanation: "Prompt yang kaya konteks akan menghasilkan output AI yang relevan dan berkualitas tinggi."
  },
  {
    id: "b3-q17",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Perancangan Konten - AI Ethics",
    text: "Sikap bijak dalam memanfaatkan Kecerdasan Artifisial (KA) untuk penyusunan karya tulis atau konten adalah...",
    options: [
      "Menyalin mentah-mentah hasil AI dan mengklaim murni buatan sendiri",
      "Menggunakan AI sebagai asisten ide dasar, dilanjutkan verifikasi fakta, dan perbaikan naskah secara mandiri",
      "Membohongi pembaca",
      "Menolak semua perkembangan teknologi"
    ],
    correctAnswerIndex: 1,
    explanation: "Integritas akademis dan etika mewajibkan adanya verifikasi fakta dan sentuhan daya kritis manusia."
  },
  {
    id: "b3-q18",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Perancangan Konten - AI Hallucination",
    text: "Fenomena ketika model Kecerdasan Artifisial memberikan jawaban fakta PALSU yang dikemas secara meyakinkan disebut...",
    options: ["AI Hallucination (Halusinasi AI)", "AI Overclock", "AI Rendering", "AI Lag"],
    correctAnswerIndex: 0,
    explanation: "Halusinasi AI adalah risiko di mana AI mengarang informasi fiktif yang terkesan ilmiah."
  },
  {
    id: "b3-q19",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Aksesibilitas Konten",
    text: "Teks alternatif (Alt Text) pada gambar dokumen digital bertujuan untuk...",
    options: [
      "Memperbesar ukuran gambar",
      "Membantu pembaca disabilitas netra melalui layar pembaca (screen reader) memahami isi gambar",
      "Menghias gambar dengan warna",
      "Menghapus gambar dari file"
    ],
    correctAnswerIndex: 1,
    explanation: "Alt Text menjamin prinsip aksesibilitas bagi penyandang disabilitas penglihatan."
  },
  {
    id: "b3-q20",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Kolaborasi Dokumen",
    text: "Fitur pada aplikasi awan (seperti Google Docs) yang memungkinkan beberapa pengguna mengedit satu dokumen bersamaan secara real-time dinamakan...",
    options: ["Real-time Collaboration", "Offline Sync", "Mail Merge", "Batch Print"],
    correctAnswerIndex: 0,
    explanation: "Kolaborasi real-time meningkatkan efisiensi kerja kelompok tanpa perlu berkirim email bolak-balik."
  },
  {
    id: "b3-q21",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Penyimpanan Awan",
    text: "Layanan penyimpanan file digital berbasis jaringan internet (seperti Google Drive, OneDrive) dinamakan...",
    options: ["Cloud Storage", "Flashdisk", "Harddisk Eksternal", "ROM"],
    correctAnswerIndex: 0,
    explanation: "Cloud storage menyimpan data di server internet sehingga dapat diakses dari mana saja."
  },
  {
    id: "b3-q22",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Tata Letak Konten",
    text: "Ruang kosong di sekitar elemen desain (teks dan gambar) yang berfungsi memberikan nafas visual dan keterbacaan rapi dinamakan...",
    options: ["White Space (Negative Space)", "Margin Error", "Blank Page", "Grid Line"],
    correctAnswerIndex: 0,
    explanation: "White space mencegah kekeringan tata letak visual dan memandu mata pembaca secara alami."
  },
  {
    id: "b3-q23",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Hak Cipta Konten",
    text: "Lisensi Creative Commons (CC) pada aset gambar internet menandakan bahwa...",
    options: [
      "Gambar ilegal digunakan",
      "Pencipta mengizinkan karyanya digunakan publik berdasarkan kriteria tertentu (misal: atribusi pencipta)",
      "Gambar harus dibeli mahal",
      "Gambar hanya boleh dilihat di HP"
    ],
    correctAnswerIndex: 1,
    explanation: "Lisensi Creative Commons mempermudah pencipta berbagi karya berhak cipta secara sah."
  },
  {
    id: "b3-q24",
    chapterId: 3,
    sectionCode: "A",
    sectionTitle: "Sistem Manajemen Dokumen",
    text: "Konvensi penamaan file dokumen yang BAIK dan terstruktur adalah...",
    options: [
      "Dokumen_tanpa_nama_final_FIX_BANGET.docx",
      "2024-08-01_Laporan_Informatika_Kelompok1.docx",
      "asdjsdkjh.docx",
      "1.docx"
    ],
    correctAnswerIndex: 1,
    explanation: "Penamaan berbasis tanggal, subjek, dan nama versi mempermudah pencarian berkas."
  },
  {
    id: "b3-q25",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Daftar Isi Dinamis",
    text: "Untuk membuat Daftar Isi Otomatis di MS Word atau Google Docs, setiap judul bab dan sub-bab harus diformat menggunakan...",
    options: ["Bold biasa", "Heading Styles (Heading 1, Heading 2)", "Italic font", "Underline"],
    correctAnswerIndex: 1,
    explanation: "Fitur Table of Contents mendeteksi elemen bab yang bertipe Heading Styles."
  },
  {
    id: "b3-q26",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Format Spreadsheet - Sel",
    text: "Pertemuan antara kolom (huruf A, B, C) dan baris (angka 1, 2, 3) dalam spreadsheet dinamakan...",
    options: ["Cell (Sel)", "Range", "Sheet", "Workbook"],
    correctAnswerIndex: 0,
    explanation: "Sel adalah kotak unit tunggal penampung data (contoh: Sel B5)."
  },
  {
    id: "b3-q27",
    chapterId: 3,
    sectionCode: "B",
    sectionTitle: "Format Spreadsheet - Range",
    text: "Kumpulan dari beberapa sel yang dipilih bersama-sama (misal dari A1 sampai A10) dinamakan...",
    options: ["Cell", "Range", "Chart", "Table"],
    correctAnswerIndex: 1,
    explanation: "Range merupakan sekumpulan sel berderet (dituliskan A1:A10)."
  },
  {
    id: "b3-q28",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Perancangan Konten - Video",
    text: "Naskah garis besar uraian adegan gambar dan suara secara runtut saat merancang konten video/vlog disebut...",
    options: ["Storyboard", "Thumbnail", "Playlists", "Captions"],
    correctAnswerIndex: 0,
    explanation: "Storyboard memandu proses pengambilan gambar dan rekaman video secara sistematis."
  },
  {
    id: "b3-q29",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Perancangan Konten - Typography",
    text: "Aturan pemilihan jenis font, ukuran, dan jarak spasi teks agar nyaman dibaca dinamakan...",
    options: ["Tipografi (Typography)", "Kaligrafi", "Orthografi", "Geografi"],
    correctAnswerIndex: 0,
    explanation: "Tipografi mengatur hierarki estetika dan keterbacaan teks media digital."
  },
  {
    id: "b3-q30",
    chapterId: 3,
    sectionCode: "C",
    sectionTitle: "Perancangan Konten - Copyright",
    text: "Tindakan menjiplak karya tulis atau ide orang lain dan mengakuinya sebagai karya sendiri disebut...",
    options: ["Plagiarisme", "Atribusi", "Sinkronisasi", "Kolaborasi"],
    correctAnswerIndex: 0,
    explanation: "Plagiarisme merupakan pelanggaran etika dan hukum Hak Kekayaan Intelektual."
  },

  // ==========================================
  // BAB IV: KEAMANAN DIGITAL (30 SOAL)
  // ==========================================
  {
    id: "b4-q1",
    chapterId: 4,
    sectionCode: "A",
    sectionTitle: "Jenis Informasi",
    text: "Data pribadi yang bersifat umum dan dapat diakses publik tanpa tingkat kerahasiaan tinggi meliputi...",
    options: [
      "Nama lengkap, jenis kelamin, dan kewarganegaraan",
      "Catatan medis penyakit dan riwayat kesehatan",
      "Nomor PIN Rekening Bank",
      "Data sidik jari dan biometrik"
    ],
    correctAnswerIndex: 0,
    explanation: "Nama lengkap dan jenis kelamin tergolong data pribadi bersifat umum menurut UU PDP."
  },
  {
    id: "b4-q2",
    chapterId: 4,
    sectionCode: "A",
    sectionTitle: "Jenis Informasi",
    text: "Manakah yang tergolong sebagai Data Pribadi Spesifik / Sensitif yang wajib dilindungi secara ketat?",
    options: [
      "Alamat email sekolah",
      "Data kesehatan biometrik, rekam medis, dan data keuangan pribadi",
      "Ukuran sepatu",
      "Warna kesukaan"
    ],
    correctAnswerIndex: 1,
    explanation: "Data kesehatan, finansial, dan biometrik adalah data sensitif yang berisiko tinggi jika bocor."
  },
  {
    id: "b4-q3",
    chapterId: 4,
    sectionCode: "B",
    sectionTitle: "Serangan Siber - Phishing",
    text: "Kejahatan siber yang menggunakan email/situs web tiruan palsu untuk memancing korban menyerahkan kata sandi atau data bank disebut...",
    options: ["Phishing", "DDoS", "Ransomware", "Spyware"],
    correctAnswerIndex: 0,
    explanation: "Phishing menyamar sebagai institusi terpercaya untuk mencuri kredensial pengguna."
  },
  {
    id: "b4-q4",
    chapterId: 4,
    sectionCode: "B",
    sectionTitle: "Serangan Siber - Malware",
    text: "Perangkat lunak berbahaya yang sengaja dirancang untuk merusak, mencuri, atau menginfeksi sistem komputer dinamakan...",
    options: ["Software", "Malware (Malicious Software)", "Freeware", "Shareware"],
    correctAnswerIndex: 1,
    explanation: "Malware adalah istilah umum mencakup virus, trojan, spyware, dan ransomware."
  },
  {
    id: "b4-q5",
    chapterId: 4,
    sectionCode: "B",
    sectionTitle: "Serangan Siber - Ransomware",
    text: "Jenis malware yang mengunci/mengenkripsi seluruh file korban dan meminta uang tebusan agar kunci file dibuka dinamakan...",
    options: ["Ransomware", "Adware", "Spam", "Cookies"],
    correctAnswerIndex: 0,
    explanation: "Ransomware menyandera berkas penting dengan enkripsi kuat demi uang tebusan."
  },
  {
    id: "b4-q6",
    chapterId: 4,
    sectionCode: "B",
    sectionTitle: "Serangan Siber - Social Engineering",
    text: "Teknik manipulasi psikologis memanfaatkan kelalaian manusia agar membocorkan rahasia informasi dinamakan...",
    options: ["Social Engineering (Rekayasa Sosial)", "SQL Injection", "Brute Force", "Port Scanning"],
    correctAnswerIndex: 0,
    explanation: "Rekayasa sosial mengeksploitasi kelemahan psikologis manusia bukan celah software."
  },
  {
    id: "b4-q7",
    chapterId: 4,
    sectionCode: "B",
    sectionTitle: "Serangan Siber - Penanganan",
    text: "Langkah PERTAMA yang wajib dilakukan jika perangkat smartphone diperkirakan terinfeksi malware adalah...",
    options: [
      "Mengabaikan ancaman",
      "Memutuskan koneksi internet, mengisolasi perangkat, dan memindai dengan Antivirus resmi",
      "Membuka semua lampiran email",
      "Mengirimkan password ke teman"
    ],
    correctAnswerIndex: 1,
    explanation: "Memutus internet mencegah malware mengirim data curian atau menyebar ke jaringan lain."
  },
  {
    id: "b4-q8",
    chapterId: 4,
    sectionCode: "C",
    sectionTitle: "Keamanan Wi-Fi Publik",
    text: "Bahaya utama yang mengintai saat kita melakukan transaksi perbankan di jaringan Wi-Fi gratisan tanpa enkripsi di kafe umum adalah...",
    options: [
      "Baterai cepat habis",
      "Penyadapan data (Man-in-the-Middle Attack) oleh penjahat siber",
      "Layar laptop menjadi redup",
      "Kamera depan menyala otomatis"
    ],
    correctAnswerIndex: 1,
    explanation: "Serangan Man-in-the-Middle (MitM) mencegat lalu lintas lalu data yang tidak dienkripsi di Wi-Fi terbuka."
  },
  {
    id: "b4-q9",
    chapterId: 4,
    sectionCode: "C",
    sectionTitle: "Keamanan Wi-Fi Publik",
    text: "Solusi teknologi yang ampuh mengamankan koneksi lalu lintas data saat harus terhubung dengan Wi-Fi publik adalah...",
    options: ["VPN (Virtual Private Network)", "GPS", "Bluetooth", "Hotspot tethering terbuka"],
    correctAnswerIndex: 0,
    explanation: "VPN membuat terowongan enkripsi terproteksi antar perangkat dan server VPN."
  },
  {
    id: "b4-q10",
    chapterId: 4,
    sectionCode: "D",
    sectionTitle: "Kata Sandi Kuat",
    text: "Manakah kombinasi Kata Sandi (Password) yang paling KUAT dan aman dari serangan Brute Force?",
    options: [
      "12345678",
      "p4ssword",
      "K3m3ndikbud#2024!S@fe",
      "tanggal_lahir"
    ],
    correctAnswerIndex: 2,
    explanation: "Password kuat memiliki panjang > 12 karakter, kombinasi huruf kapital, kecil, angka, dan simbol khusus."
  },
  {
    id: "b4-q11",
    chapterId: 4,
    sectionCode: "D",
    sectionTitle: "Autentikasi 2FA",
    text: "Fitur keamanan berlapis yang meminta verifikasi kode tambahan (OTP/SMS/Authenticator App) selain password saat login dinamakan...",
    options: ["Two-Factor Authentication (2FA)", "Single Sign-On", "Auto Fill", "Remember Me"],
    correctAnswerIndex: 0,
    explanation: "2FA memastikan akun tetap aman meski password utama tidak sengaja bocor."
  },
  {
    id: "b4-q12",
    chapterId: 4,
    sectionCode: "D",
    sectionTitle: "Kode OTP",
    text: "Sifat utama dari kode OTP (One-Time Password) yang dikirimkan melalui SMS/Aplikasi adalah...",
    options: [
      "Boleh dibagikan ke siapapun",
      "Rahasia, berlaku sekali pakai, dan memiliki durasi kadaluarsa singkat",
      "Berlaku selamanya",
      "Sama untuk semua akun"
    ],
    correctAnswerIndex: 1,
    explanation: "OTP bersifat sangat rahasia dan tidak boleh diserahkan kepada pihak lain dengan alasan apapun."
  },
  {
    id: "b4-q13",
    chapterId: 4,
    sectionCode: "D",
    sectionTitle: "Enkripsi & Dekripsi",
    text: "Proses mengacak data teks biasa menjadi teks sandi rahasia agar tidak bisa dibaca pihak tak berwenang dinamakan...",
    options: ["Dekripsi", "Enkripsi", "Kompresi", "Restorasi"],
    correctAnswerIndex: 1,
    explanation: "Enkripsi menyandikan plaintext menjadi ciphertext."
  },
  {
    id: "b4-q14",
    chapterId: 4,
    sectionCode: "D",
    sectionTitle: "Enkripsi & Dekripsi",
    text: "Proses mengembalikan teks sandi rahasia (ciphertext) menjadi teks semula (plaintext) menggunakan kunci dinamakan...",
    options: ["Enkripsi", "Dekripsi", "Instalasi", "Pengarsipan"],
    correctAnswerIndex: 1,
    explanation: "Dekripsi menerjemahkan ciphertext kembali menjadi data pesan asli."
  },
  {
    id: "b4-q15",
    chapterId: 4,
    sectionCode: "D",
    sectionTitle: "Protokol HTTPS",
    text: "Tanda ikon gembok terkuci dan awalan `https://` pada URL browser menunjukkan bahwa...",
    options: [
      "Situs web berbahaya",
      "Komunikasi data antara browser dan web server dienkripsi secara aman dengan SSL/TLS",
      "Situs web gratis",
      "Komputer terbebas virus"
    ],
    correctAnswerIndex: 1,
    explanation: "HTTPS menjamin saluran data dienkripsi sehingga aman dari penyadapan."
  },
  {
    id: "b4-q16",
    chapterId: 4,
    sectionCode: "D",
    sectionTitle: "Software Update",
    text: "Tujuan utama memperbarui (update) sistem operasi dan aplikasi secara berkala adalah...",
    options: [
      "Menghabiskan kuota internet",
      "Menutup celah kerentanan keamanan (security patch) dan meningkatkan stabilitas",
      "Mengubah warna layar",
      "Menghapus seluruh file foto"
    ],
    correctAnswerIndex: 1,
    explanation: "Pembaruan rutin menutup bug keamanan yang sering dieksploitasi oleh hacker."
  },
  {
    id: "b4-q17",
    chapterId: 4,
    sectionCode: "E",
    sectionTitle: "Perilaku Digital",
    text: "Etika dasar berkomunikasi di internet (Netiket) yang wajib dijaga oleh generasi digital adalah...",
    options: [
      "Menyebarkan ujaran kebencian di kolom komentar",
      "Saling menghargai pendapat, tidak menyebar hoaks, dan berbahasa santun",
      "Meretas akun teman",
      "Mengunggah identitas KTP orang lain"
    ],
    correctAnswerIndex: 1,
    explanation: "Netiket mengatur norma sopan santun dan kedewasaan berinteraksi di ruang publik virtual."
  },
  {
    id: "b4-q18",
    chapterId: 4,
    sectionCode: "E",
    sectionTitle: "Mindfulness Digital",
    text: "Konsep Digital Mindfulness mengajarkan pengguna internet untuk...",
    options: [
      "Bermain HP 24 jam nonstop",
      "Sadar penuh, bijak membatasi waktu layar (screen time), dan menjaga keseimbangan kehidupan nyata",
      "Menjauhi semua teknologi",
      "Selalu membalas chat dalam hitungan detik"
    ],
    correctAnswerIndex: 1,
    explanation: "Digital mindfulness menekankan kesadaran penuh dan kesehatan mental saat menggunakan media digital."
  },
  {
    id: "b4-q19",
    chapterId: 4,
    sectionCode: "E",
    sectionTitle: "Digital Detox",
    text: "Praktik menghentikan sementara penggunaan gadget dan media sosial untuk menyegarkan mental dinamakan...",
    options: ["Digital Detox", "Digital Marketing", "Digital Branding", "Digital Footprint"],
    correctAnswerIndex: 0,
    explanation: "Digital Detox memulihkan fokus dan kesehatan mental dari paparan berlebih dunia maya."
  },
  {
    id: "b4-q20",
    chapterId: 4,
    sectionCode: "E",
    sectionTitle: "Cyberbullying",
    text: "Tindakan perundungan, intimidasi, atau pelecehan secara berulang yang dilakukan melalui media digital disebut...",
    options: ["Cyberbullying", "Phishing", "Spamming", "Browsing"],
    correctAnswerIndex: 0,
    explanation: "Cyberbullying merusak kesehatan mental korban melalui teror pesan atau ujaran kebencian."
  },
  {
    id: "b4-q21",
    chapterId: 4,
    sectionCode: "E",
    sectionTitle: "Jejak Digital",
    text: "Rekam jejak seluruh aktivitas yang kita tinggalkan saat berselancar di internet (seperti postingan, pencarian, komentar) disebut...",
    options: ["Jejak Digital (Digital Footprint)", "Sejarah Komputer", "Cookies", "Cache"],
    correctAnswerIndex: 0,
    explanation: "Jejak digital bersifat permanen dan dapat mempengaruhi reputasi personal di masa depan."
  },
  {
    id: "b4-q22",
    chapterId: 4,
    sectionCode: "B",
    sectionTitle: "Penipuan Online",
    text: "Modus penipuan berkedok pesan pengiriman paket atau undangan pernikahan format file `.apk` bertujuan untuk...",
    options: [
      "Mengirimkan hadiah gratis",
      "Memasang malware peretas SMS/OTP tanpa disadari pengguna",
      "Memperbaiki HP rusak",
      "Memberikan kuota gratis"
    ],
    correctAnswerIndex: 1,
    explanation: "File .apk asing menyusupkan spyware untuk mencuri akses perbankan dan OTP korban."
  },
  {
    id: "b4-q23",
    chapterId: 4,
    sectionCode: "D",
    sectionTitle: "Penyimpanan Cadangan",
    text: "Tindakan membuat salinan cadangan data penting ke media penyimpanan terpisah secara rutin dinamakan...",
    options: ["Backup Data", "Delete Data", "Format Data", "Syncing"],
    correctAnswerIndex: 0,
    explanation: "Backup data melindungi informasi dari kerusakan perangkat keras atau ancaman ransomware."
  },
  {
    id: "b4-q24",
    chapterId: 4,
    sectionCode: "D",
    sectionTitle: "Firewall",
    text: "Sistem keamanan jaringan yang berfungsi memfilter dan memblokir lalu lintas data mencurigakan yang masuk ke komputer dinamakan...",
    options: ["Antivirus", "Firewall", "Router", "Modem"],
    correctAnswerIndex: 1,
    explanation: "Firewall bertindak sebagai dinding pertahanan antara jaringan internal dan jaringan luar."
  },
  {
    id: "b4-q25",
    chapterId: 4,
    sectionCode: "E",
    sectionTitle: "FOMO (Fear Of Missing Out)",
    text: "Perasaan cemas berlebihan takut tertinggal tren atau informasi terbaru di media sosial dinamakan istilah...",
    options: ["FOMO (Fear Of Missing Out)", "JOMO", "LOL", "AFK"],
    correctAnswerIndex: 0,
    explanation: "FOMO memicu ketagihan memeriksa HP secara impulsif yang merusak konsentrasi belajar."
  },
  {
    id: "b4-q26",
    chapterId: 4,
    sectionCode: "A",
    sectionTitle: "Perlindungan Hak Akses",
    text: "Prinsip memberikan hak akses data HANYA kepada pihak yang benar-benar membutuhkan (Principle of Least Privilege) bertujuan untuk...",
    options: [
      "Membuat sistem lambat",
      "Meminimalkan potensi kebocoran data akibat akses tak berwenang",
      "Menambah beban memori",
      "Menghilangkan fungsi sandi"
    ],
    correctAnswerIndex: 1,
    explanation: "Membatasi wewenang akun mengurangi risiko penyalahgunaan sistem secara signifikan."
  },
  {
    id: "b4-q27",
    chapterId: 4,
    sectionCode: "B",
    sectionTitle: "Karakteristik Virus Komputer",
    text: "Program komputer yang dapat menggandakan dirinya sendiri dan menyebar dari satu komputer ke komputer lain dinamakan...",
    options: ["Virus / Worm Komputer", "Database", "Browser", "Driver"],
    correctAnswerIndex: 0,
    explanation: "Worm dan virus mereplikasi diri dan mengonsumsi sumber daya memori jaringan."
  },
  {
    id: "b4-q28",
    chapterId: 4,
    sectionCode: "C",
    sectionTitle: "Situs Palsu (Fake Site)",
    text: "Ciri-ciri alamat domain website phishing palsu yang patut dicurigai adalah...",
    options: [
      "Nama domain janggal seperti `www.bank-indonesia-login-keamanan.xyz`",
      "Domain resmi berakhiran .go.id atau .ac.id",
      "Memiliki sertifikat keamanan valid",
      "Tampil di halaman resmi pemerintah"
    ],
    correctAnswerIndex: 0,
    explanation: "Website phishing sering menggunakan domain tiruan dengan ejaan sedikit berbeda."
  },
  {
    id: "b4-q29",
    chapterId: 4,
    sectionCode: "E",
    sectionTitle: "Kesehatan Fisik Digital",
    text: "Aturan 20-20-20 untuk mencegah kelelahan mata saat menatap layar komputer artinya...",
    options: [
      "Bermain game 20 jam, istirahat 20 menit, makan 20 gram",
      "Setiap 20 menit menatap layar, istirahatkan mata 20 detik melihat objek sejauh 20 kaki (6 meter)",
      "Membeli 20 layar baru",
      "Mematikan HP selama 20 hari"
    ],
    correctAnswerIndex: 1,
    explanation: "Aturan 20-20-20 direkomendasikan dokter mata untuk melemaskan otot fokus mata saat berlayar."
  },
  {
    id: "b4-q30",
    chapterId: 4,
    sectionCode: "E",
    sectionTitle: "Penyebaran Berita Hoaks",
    text: "Langkah terpenting sebelum menyebarkan berita menarik dari media sosial ke grup percakapan adalah...",
    options: [
      "Langsung membagikan secara cepat",
      "Mengecek kebenaran sumber berita di situs saring hoaks (Cek Fakta) dan membaca secara menyeluruh",
      "Menambahkan bumbu cerita seram",
      "Menghapus nama penulis asli"
    ],
    correctAnswerIndex: 1,
    explanation: "Literasi digital menuntut verifikasi fakta (Saring sebelum Sharing) untuk memutus rantai hoaks."
  },

  // ==========================================
  // BAB V (TAMBAHAN): ALGORITMA PEMROGRAMAN APLIKASI SCRATCH (30 SOAL)
  // ==========================================
  {
    id: "b5-q1",
    chapterId: 5,
    sectionCode: "A",
    sectionTitle: "Konsep Dasar & Antarmuka Aplikasi Scratch",
    text: "Scratch merupakan salah satu lingkungan pemrograman visual yang mempermudah pemula belajar koding karena menggunakan metode...",
    options: [
      "Penulisan sintaks kode berupa teks panjang",
      "Penyusunan blok-blok perintah visual (Drag and Drop)",
      "Pengeditan dokumen teks sederhana",
      "Pengembangan bahasa mesin secara langsung"
    ],
    correctAnswerIndex: 1,
    explanation: "Scratch dirancang oleh MIT Media Lab dengan konsep pemrograman berbasis blok visual yang disusun dengan cara digeser dan dilepas (drag and drop)."
  },
  {
    id: "b5-q2",
    chapterId: 5,
    sectionCode: "A",
    sectionTitle: "Konsep Dasar & Antarmuka Aplikasi Scratch",
    text: "Dalam aplikasi Scratch, istilah untuk objek gambar atau karakter yang dapat diberi perintah dan bergerak dinamakan...",
    options: ["Backdrop", "Sprite", "Stage", "Costume"],
    correctAnswerIndex: 1,
    explanation: "Sprite adalah objek visual (seperti kucing Kucing Scratch, pemain, atau rintangan) yang dapat dikendalikan melalui skrip program."
  },
  {
    id: "b5-q3",
    chapterId: 5,
    sectionCode: "A",
    sectionTitle: "Konsep Dasar & Antarmuka Aplikasi Scratch",
    text: "Area panggung utama pada Scratch yang berfungsi menampilkan hasil pergerakan Sprite dan interaksi animasi dinamakan...",
    options: ["Script Area", "Blocks Palette", "Stage", "Sprite List"],
    correctAnswerIndex: 2,
    explanation: "Stage (Panggung) adalah area keluaran visual tempat seluruh Sprite bertindak dan menjalankan skrip yang telah diprogram."
  },
  {
    id: "b5-q4",
    chapterId: 5,
    sectionCode: "A",
    sectionTitle: "Konsep Dasar & Antarmuka Aplikasi Scratch",
    text: "Latar belakang visual yang menghiasi panggung (Stage) dalam Scratch disebut...",
    options: ["Costume", "Backdrop", "Canvas", "Palette"],
    correctAnswerIndex: 1,
    explanation: "Backdrop adalah gambar latar belakang yang dipasang pada Stage untuk mempercantik atau memperjelas alur proyek/game."
  },
  {
    id: "b5-q5",
    chapterId: 5,
    sectionCode: "A",
    sectionTitle: "Konsep Dasar & Antarmuka Aplikasi Scratch",
    text: "Format ekstensi file standar saat menyimpan proyek yang dibuat menggunakan Scratch 3.0 adalah...",
    options: [".sb3", ".exe", ".docx", ".py"],
    correctAnswerIndex: 0,
    explanation: "Proyek yang dibuat pada Scratch versi 3.0 disimpan dalam format file berekstensi .sb3."
  },
  {
    id: "b5-q6",
    chapterId: 5,
    sectionCode: "A",
    sectionTitle: "Konsep Dasar & Antarmuka Aplikasi Scratch",
    text: "Fitur pada Scratch yang memungkinkan sebuah Sprite memiliki beberapa bentuk penampilan/pose bergantian agar terlihat berjalan atau bernyawa dinamakan...",
    options: ["Backdrop", "Costumes", "Sounds", "Variables"],
    correctAnswerIndex: 1,
    explanation: "Costumes (Kostum) berisi sekumpulan variasi visual/pose dari satu Sprite untuk menciptakan animasi perpindahan gerakan."
  },
  {
    id: "b5-q7",
    chapterId: 5,
    sectionCode: "A",
    sectionTitle: "Konsep Dasar & Antarmuka Aplikasi Scratch",
    text: "Ikon Bendera Hijau (Green Flag) di sudut atas area Stage Scratch digunakan untuk...",
    options: [
      "Menghapus seluruh Sprite di panggung",
      "Menjalankan atau memulai eksekusi skrip program",
      "Menghentikan secara paksa seluruh animasi",
      "Menyimpan proyek ke memori komputer"
    ],
    correctAnswerIndex: 1,
    explanation: "Ikon Bendera Hijau merupakan tombol utama pemicu pemicuan skrip yang diawali blok 'when green flag clicked'."
  },
  {
    id: "b5-q8",
    chapterId: 5,
    sectionCode: "B",
    sectionTitle: "Gerak, Tampilan, dan Suara (Motion, Looks, Sound)",
    text: "Blok perintah `move (10) steps` yang berwarna biru tergolong dalam kelompok kategori blok...",
    options: ["Looks", "Motion", "Control", "Events"],
    correctAnswerIndex: 1,
    explanation: "Kategori Motion (Gerakan) berisi blok-blok berwarna biru untuk mengatur posisi, arah, dan pergerakan Sprite."
  },
  {
    id: "b5-q9",
    chapterId: 5,
    sectionCode: "B",
    sectionTitle: "Gerak, Tampilan, dan Suara (Motion, Looks, Sound)",
    text: "Titik pusat koordinat (origin point) pada panggung (Stage) Scratch yang berukuran 480x360 piksel terletak pada posisi koordinat...",
    options: ["X: 240, Y: 180", "X: 0, Y: 0", "X: -240, Y: -180", "X: 100, Y: 100"],
    correctAnswerIndex: 1,
    explanation: "Pusat panggung Scratch merupakan titik pertemuan sumbu horizontal (X) dan vertikal (Y) yaitu titik X: 0 dan Y: 0."
  },
  {
    id: "b5-q10",
    chapterId: 5,
    sectionCode: "B",
    sectionTitle: "Gerak, Tampilan, dan Suara (Motion, Looks, Sound)",
    text: "Blok perintah yang digunakan untuk memindahkan posisi Sprite secara instan ke titik koordinat tertentu tanpa animasi meluncur adalah...",
    options: [
      "glide (1) secs to x: (0) y: (0)",
      "go to x: (0) y: (0)",
      "change x by (10)",
      "point in direction (90)"
    ],
    correctAnswerIndex: 1,
    explanation: "Blok `go to x: () y: ()` langsung menempatkan Sprite pada posisi sumbu X dan Y target secara seketika."
  },
  {
    id: "b5-q11",
    chapterId: 5,
    sectionCode: "B",
    sectionTitle: "Gerak, Tampilan, dan Suara (Motion, Looks, Sound)",
    text: "Supaya Sprite tidak berjalan menembus dan membal balik ketika menabrak batas pinggir panggung, blok perintah yang harus ditambahkan di dalam perulangan gerakan adalah...",
    options: [
      "if on edge, bounce",
      "turn right (15) degrees",
      "set rotation style [don't rotate]",
      "touching [edge]?"
    ],
    correctAnswerIndex: 0,
    explanation: "Blok `if on edge, bounce` (jika di pinggir, memantul) secara otomatis membalikkan arah pergerakan Sprite saat menyentuh tepi Stage."
  },
  {
    id: "b5-q12",
    chapterId: 5,
    sectionCode: "B",
    sectionTitle: "Gerak, Tampilan, dan Suara (Motion, Looks, Sound)",
    text: "Untuk menampilkan percakapan berbentuk balon teks di samping Sprite selama durasi waktu tertentu, kita dapat menggunakan blok...",
    options: [
      "say [Hello!] for (2) seconds",
      "think [Hmm...]",
      "switch costume to [costume1]",
      "change size by (10)"
    ],
    correctAnswerIndex: 0,
    explanation: "Blok `say [...] for (...) seconds` dari kategori Looks membuat balon dialog berisi teks yang hilang otomatis setelah beberapa detik."
  },
  {
    id: "b5-q13",
    chapterId: 5,
    sectionCode: "B",
    sectionTitle: "Gerak, Tampilan, dan Suara (Motion, Looks, Sound)",
    text: "Kelompok blok yang memiliki warna merah muda/magenta dan berfungsi memutar efek suara atau musik pada proyek dinamakan...",
    options: ["Looks", "Motion", "Sound", "Sensing"],
    correctAnswerIndex: 2,
    explanation: "Kategori Sound memuat blok-blok seperti `play sound () until done`, `start sound ()`, dan pengatur volume suara."
  },
  {
    id: "b5-q14",
    chapterId: 5,
    sectionCode: "B",
    sectionTitle: "Gerak, Tampilan, dan Suara (Motion, Looks, Sound)",
    text: "Untuk berpindah ke kostum berikutnya secara berurutan guna menciptakan efek animasi Sprite berjalan, blok yang paling efisien digunakan adalah...",
    options: [
      "switch costume to [costume1]",
      "next costume",
      "switch backdrop to [backdrop1]",
      "show"
    ],
    correctAnswerIndex: 1,
    explanation: "Blok `next costume` langsung berpindah ke kostum urutan berikutnya tanpa harus menyebutkan nama kostum secara manual."
  },
  {
    id: "b5-q15",
    chapterId: 5,
    sectionCode: "B",
    sectionTitle: "Gerak, Tampilan, dan Suara (Motion, Looks, Sound)",
    text: "Saat Sprite berbalik arah ke kiri dan terlihat dalam posisi terbalik (kepala di bawah), perintah untuk mengunci arah rotasi agar tetap tegak adalah...",
    options: [
      "set rotation style [left-right]",
      "set rotation style [all around]",
      "set rotation style [don't rotate]",
      "point in direction (-90)"
    ],
    correctAnswerIndex: 0,
    explanation: "`set rotation style [left-right]` memastikan Sprite hanya bercermin ke kiri/kanan tanpa memutar posisinya secara terbalik."
  },
  {
    id: "b5-q16",
    chapterId: 5,
    sectionCode: "C",
    sectionTitle: "Logika Kontrol, Perulangan & Kondisional (Events, Control, Sensing)",
    text: "Blok-blok pemicu bertopi melengkung seperti `when green flag clicked` atau `when [space] key pressed` dikelompokkan dalam kategori...",
    options: ["Control", "Events", "Sensing", "Operators"],
    correctAnswerIndex: 1,
    explanation: "Kategori Events (Kejadian) berisi penanda/pemicu awal dimulainya eksekusi suatu rantai skrip program."
  },
  {
    id: "b5-q17",
    chapterId: 5,
    sectionCode: "C",
    sectionTitle: "Logika Kontrol, Perulangan & Kondisional (Events, Control, Sensing)",
    text: "Perbedaan mendasar antara blok perulangan `repeat (10)` dan blok `forever` pada kategori Control adalah...",
    options: [
      "`repeat (10)` hanya untuk suara, sedangkan `forever` untuk gerakan",
      "`repeat (10)` mengeksekusi blok sebanyak 10 kali, sedangkan `forever` mengeksekusi tanpa henti sampai program dihentikan",
      "`forever` akan berhenti sendiri setelah 100 kali perulangan",
      "Keduanya memiliki fungsi yang persis sama tanpa beda"
    ],
    correctAnswerIndex: 1,
    explanation: "Blok `repeat (n)` melakukan iterasi dengan jumlah terbatas (n kali), sementara `forever` melakukan perulangan tak berhingga (infinite loop)."
  },
  {
    id: "b5-q18",
    chapterId: 5,
    sectionCode: "C",
    sectionTitle: "Logika Kontrol, Perulangan & Kondisional (Events, Control, Sensing)",
    text: "Sintaks percabangan dua kondisi 'Jika Kondisi Benar lakukan X, Jika Salah lakukan Y' diprogram dalam Scratch menggunakan blok...",
    options: [
      "if < > then",
      "if < > then ... else ...",
      "wait until < >",
      "repeat until < >"
    ],
    correctAnswerIndex: 1,
    explanation: "Blok `if < > then ... else ...` menyediakan dua jalur eksekusi: rantai blok pertama jika bernilai benar (True) dan rantai blok 'else' jika bernilai salah (False)."
  },
  {
    id: "b5-q19",
    chapterId: 5,
    sectionCode: "C",
    sectionTitle: "Logika Kontrol, Perulangan & Kondisional (Events, Control, Sensing)",
    text: "Fungsi dari blok perintah `wait (1) seconds` dalam skrip program Scratch adalah...",
    options: [
      "Mematikan aplikasi Scratch selama 1 detik",
      "Memberikan jeda waktu penundaan sebelum mengeksekusi blok perintah di bawahnya",
      "Mempercepat pergerakan Sprite sebanyak 1 detik",
      "Mengulang perintah sebelumnya selama 1 detik"
    ],
    correctAnswerIndex: 1,
    explanation: "Blok `wait () seconds` menunda jalannya rantai skrip pada Sprite tersebut sesuai jumlah detik yang ditentukan."
  },
  {
    id: "b5-q20",
    chapterId: 5,
    sectionCode: "C",
    sectionTitle: "Logika Kontrol, Perulangan & Kondisional (Events, Control, Sensing)",
    text: "Untuk memodelkan deteksi benturan (collision) antara Sprite karakter utama dengan Sprite rintangan/musuh, blok sensing yang tepat digunakan adalah...",
    options: [
      "touching [mouse-pointer]?",
      "touching [Sprite2]?",
      "distance to [Sprite2]",
      "key [space] pressed?"
    ],
    correctAnswerIndex: 1,
    explanation: "Blok `touching [Sprite2]?` mengembalikan nilai True ketika area piksel Sprite utama bersentuhan dengan Sprite2."
  },
  {
    id: "b5-q21",
    chapterId: 5,
    sectionCode: "C",
    sectionTitle: "Logika Kontrol, Perulangan & Kondisional (Events, Control, Sensing)",
    text: "Saat menggunakan blok `ask [Siapa namamu?] and wait`, jawaban teks yang diketikkan pengguna di layar akan tersimpan secara otomatis pada blok variabel bawaan yaitu...",
    options: ["name", "answer", "input", "text"],
    correctAnswerIndex: 1,
    explanation: "Variabel bawaan `answer` pada kategori Sensing secara otomatis menampung string input terbaru yang dimasukkan pengguna."
  },
  {
    id: "b5-q22",
    chapterId: 5,
    sectionCode: "C",
    sectionTitle: "Logika Kontrol, Perulangan & Kondisional (Events, Control, Sensing)",
    text: "Untuk membangkitkan angka acak (misalnya pengocokan dadu bernilai 1 sampai 6), kita dapat menggunakan blok Operators yaitu...",
    options: [
      "pick random (1) to (6)",
      "join (1) (6)",
      "round (1.6)",
      "mod (1) (6)"
    ],
    correctAnswerIndex: 0,
    explanation: "Blok `pick random (a) to (b)` menghasilkan bilangan acak di dalam rentang rentang terendah hingga tertinggi yang diisikan."
  },
  {
    id: "b5-q23",
    chapterId: 5,
    sectionCode: "C",
    sectionTitle: "Logika Kontrol, Perulangan & Kondisional (Events, Control, Sensing)",
    text: "Blok perintah pada kategori Control yang digunakan untuk menghentikan seluruh aktivitas skrip proyek yang sedang berjalan adalah...",
    options: [
      "stop [all]",
      "stop [this script]",
      "stop [other scripts in sprite]",
      "delete this clone"
    ],
    correctAnswerIndex: 0,
    explanation: "Blok `stop [all]` langsung memberhentikan seluruh skrip pada semua Sprite dan Stage secara total."
  },
  {
    id: "b5-q24",
    chapterId: 5,
    sectionCode: "D",
    sectionTitle: "Variabel, Daftar, dan Pesan Siaran (Variables, Lists & Broadcast)",
    text: "Elemen pemrogramam dalam Scratch yang digunakan sebagai tempat menyimpan data berupa nilai numerik atau teks yang nilainya dapat berubah selama program berjalan (seperti Skor, Nyawa, atau Timer) dinamakan...",
    options: ["Costume", "Variable", "Broadcast", "Backdrop"],
    correctAnswerIndex: 1,
    explanation: "Variable (Variabel) adalah wadah penyimpanan nilai di memori yang dapat dibaca dan diubah sewaktu-waktu oleh skrip program."
  },
  {
    id: "b5-q25",
    chapterId: 5,
    sectionCode: "D",
    sectionTitle: "Variabel, Daftar, dan Pesan Siaran (Variables, Lists & Broadcast)",
    text: "Guna menambah nilai variabel [Skor] sebanyak 1 poin setiap kali pemain berhasil mengumpulkan koin, perintah Scratch yang benar adalah...",
    options: [
      "set [Skor] to (1)",
      "change [Skor] by (1)",
      "show variable [Skor]",
      "show [Skor] (1)"
    ],
    correctAnswerIndex: 1,
    explanation: "`change [Skor] by (1)` menambahkan nilai lama variabel dengan nilai +1, sedangkan `set [Skor] to (1)` akan selalu mengubah total skor menjadi tepat angka 1."
  },
  {
    id: "b5-q26",
    chapterId: 5,
    sectionCode: "D",
    sectionTitle: "Variabel, Daftar, dan Pesan Siaran (Variables, Lists & Broadcast)",
    text: "Mekanisme komunikasi rahasia antar-Sprite atau antara Sprite dengan Stage untuk memicu aksi bersama (misalnya saat merespons event Game Over) menggunakan fitur...",
    options: ["Sensing", "Broadcast Message", "Cloning", "Custom Sound"],
    correctAnswerIndex: 1,
    explanation: "Broadcast Message memungkinkan suatu Sprite mengirimkan sinyal siaran teks pesan ke seluruh Sprite lain agar merespons pemicu tersebut."
  },
  {
    id: "b5-q27",
    chapterId: 5,
    sectionCode: "D",
    sectionTitle: "Variabel, Daftar, dan Pesan Siaran (Variables, Lists & Broadcast)",
    text: "Sprite penerima pesan siaran akan mulai mengeksekusi skrip tanggapannya ketika dipicu oleh blok pemicu Events bernama...",
    options: [
      "broadcast [Pesan1]",
      "broadcast [Pesan1] and wait",
      "when I receive [Pesan1]",
      "when key [Pesan1] pressed"
    ],
    correctAnswerIndex: 2,
    explanation: "Blok `when I receive [nama_pesan]` dipasang di Sprite penerima untuk merespons sinyal yang dipancarkan blok `broadcast`."
  },
  {
    id: "b5-q28",
    chapterId: 5,
    sectionCode: "D",
    sectionTitle: "Variabel, Daftar, dan Pesan Siaran (Variables, Lists & Broadcast)",
    text: "Dalam pembuatannya, jenis variabel Scratch yang dapat diakses, dibaca, dan dimodifikasi oleh seluruh Sprite yang ada pada proyek dinamakan...",
    options: [
      "For all sprites (Variabel Global)",
      "For this sprite only (Variabel Lokal)",
      "Cloud variable",
      "List variable"
    ],
    correctAnswerIndex: 0,
    explanation: "Variabel bertipe 'For all sprites' bersifat Global sehingga nilainya dapat dibaca dan diperbarui oleh skrip pada Sprite mana saja."
  },
  {
    id: "b5-q29",
    chapterId: 5,
    sectionCode: "D",
    sectionTitle: "Variabel, Daftar, dan Pesan Siaran (Variables, Lists & Broadcast)",
    text: "Fitur 'Make a Block' pada kelompok kategori 'My Blocks' dalam Scratch digunakan oleh pemrogram untuk...",
    options: [
      "Mengunduh blok baru dari internet",
      "Membuat fungsi/subrutin baru kustom guna modularisasi skrip yang berulang",
      "Menghapus blok-blok bawaan yang tidak terpakai",
      "Mengubah warna tema aplikasi Scratch"
    ],
    correctAnswerIndex: 1,
    explanation: "My Blocks (Custom Blocks) memungkinkan kita mendefinisikan blok fungsi buatan sendiri untuk menyederhanakan dan merapikan kode (konsep pemrograman modular)."
  },
  {
    id: "b5-q30",
    chapterId: 5,
    sectionCode: "D",
    sectionTitle: "Variabel, Daftar, dan Pesan Siaran (Variables, Lists & Broadcast)",
    text: "Pada skenario game Scratch: Ketika [Nyawa] = 0, skrip mengeksekusi `broadcast [Kalah]`. Tindakan terbaik pada Sprite Latar (Stage) saat menerima pesan [Kalah] adalah...",
    options: [
      "Mengganti backdrop ke tampilan 'Game Over' lalu menjalankan blok `stop [all]`",
      "Menambah nilai [Nyawa] menjadi 100 secara otomatis",
      "Menggerakkan Sprite utama sejauh 100 langkah",
      "Menghapus seluruh file proyek dari komputer"
    ],
    correctAnswerIndex: 0,
    explanation: "Saat sinyal 'Kalah' diterima, Stage sebaiknya mengganti tampilan latar belakang ke layar Game Over dan menghentikan seluruh jalannya game menggunakan `stop [all]`."
  },

  // ==========================================
  // BAB KOKURIKULER: LITERASI DAN NUMERASI DALAM INFORMATIKA
  // ==========================================

  // Sub-Bab A: Sistem Bilangan Biner & Representasi Data Digital (Numerasi)
  {
    id: "b6-q1",
    chapterId: 6,
    sectionCode: "A",
    sectionTitle: "Sistem Bilangan Biner & Representasi Data Digital (Numerasi)",
    text: "Alasan mendasar mengapa sirkuit perangkat keras komputer digital memproses seluruh data dalam bentuk sistem bilangan biner (basis 2) adalah karena...",
    options: [
      "Transistor mikroelektronika hanya memiliki dua kondisi fisik stabil, yaitu On (ada arus/1) dan Off (tidak ada arus/0)",
      "Sistem biner lebih mudah dihitung secara manual oleh manusia daripada sistem desimal",
      "Komputer tidak memiliki memori penyimpanan yang cukup untuk menyimpan angka lebih dari 1",
      "Sistem desimal dilarang oleh standar internasional teknologi informasi"
    ],
    correctAnswerIndex: 0,
    explanation: "Sirkuit mikroprosesor komputer tersusun atas miliaran transistor yang bekerja seperti sakelar On/Off (keadaan biner 1 dan 0)."
  },
  {
    id: "b6-q2",
    chapterId: 6,
    sectionCode: "A",
    sectionTitle: "Sistem Bilangan Biner & Representasi Data Digital (Numerasi)",
    text: "Sistem bilangan yang berbasis 16 dan menggunakan simbol angka 0 sampai 9 serta huruf A sampai F dinamakan sistem...",
    options: [
      "Biner",
      "Oktal",
      "Desimal",
      "Heksadesimal"
    ],
    correctAnswerIndex: 3,
    explanation: "Heksadesimal adalah sistem bilangan basis 16 yang menggunakan simbol 0-9 dan A (10), B (11), C (12), D (13), E (14), F (15)."
  },
  {
    id: "b6-q3",
    chapterId: 6,
    sectionCode: "A",
    sectionTitle: "Sistem Bilangan Biner & Representasi Data Digital (Numerasi)",
    text: "Urutan kapasitas data digital dari yang terkecil hingga terbesar yang benar adalah...",
    options: [
      "Bit → Byte → Kilobyte (KB) → Megabyte (MB) → Gigabyte (GB) → Terabyte (TB)",
      "Byte → Bit → Megabyte (MB) → Kilobyte (KB) → Terabyte (TB) → Gigabyte (GB)",
      "Bit → Nibble → Megabyte (MB) → Kilobyte (KB) → Gigabyte (GB) → Terabyte (TB)",
      "Byte → Kilobyte (KB) → Terabyte (TB) → Gigabyte (GB) → Megabyte (MB)"
    ],
    correctAnswerIndex: 0,
    explanation: "Satuan data berurutan mulai dari 1 Bit (0/1), 1 Byte (8 bit), 1 KB (1.024 Byte), 1 MB (1.024 KB), 1 GB (1.024 MB), hingga 1 TB (1.024 GB)."
  },
  {
    id: "b6-q4",
    chapterId: 6,
    sectionCode: "A",
    sectionTitle: "Sistem Bilangan Biner & Representasi Data Digital (Numerasi)",
    text: "Berapa banyak kombinasi nilai biner berbeda yang dapat ditampung oleh 1 Byte data (8 bit)?",
    options: [
      "8 kombinasi",
      "64 kombinasi",
      "128 kombinasi",
      "256 kombinasi (2⁸)"
    ],
    correctAnswerIndex: 3,
    explanation: "Karena tiap bit memiliki 2 kemungkinan (0 atau 1), maka 8 bit (1 Byte) menghasilkan 2⁸ = 256 kemungkinan nilai unik (0 s.d. 255)."
  },
  {
    id: "b6-q5",
    chapterId: 6,
    sectionCode: "A",
    sectionTitle: "Sistem Bilangan Biner & Representasi Data Digital (Numerasi)",
    text: "Pada sistem pengkodean teks ASCII, huruf kapital 'A' direpresentasikan dengan nilai desimal 65. Bentuk bilangan biner 8-bit dari karakter 'A' tersebut adalah...",
    options: [
      "01000001",
      "01000010",
      "00100001",
      "10000001"
    ],
    correctAnswerIndex: 0,
    explanation: "65 = 64 + 1 = (0 × 128) + (1 × 64) + (0 × 32) + (0 × 16) + (0 × 8) + (0 × 4) + (0 × 2) + (1 × 1) = 01000001₂."
  },
  {
    id: "b6-q6",
    chapterId: 6,
    sectionCode: "A",
    sectionTitle: "Sistem Bilangan Biner & Representasi Data Digital (Numerasi)",
    text: "Pada pemrosesan warna citra digital sistem RGB 24-bit TrueColor, warna putih murni direpresentasikan dengan nilai heksadesimal #FFFFFF yang setara dengan komposisi kanal RGB...",
    options: [
      "R: 0, G: 0, B: 0",
      "R: 255, G: 255, B: 255",
      "R: 255, G: 0, B: 0",
      "R: 128, G: 128, B: 128"
    ],
    correctAnswerIndex: 1,
    explanation: "Warna putih pada monitor dihasilkan dari intensitas maksimum ketiga kanal warna RGB (255, 255, 255) yang dalam heksadesimal bernilai #FFFFFF."
  },

  // Sub-Bab B: Konversi Bilangan Biner & Operasi Aritmatika Digital (Numerasi)
  {
    id: "b6-q7",
    chapterId: 6,
    sectionCode: "B",
    sectionTitle: "Konversi Bilangan Biner & Operasi Aritmatika Digital (Numerasi)",
    text: "Hasil konversi bilangan biner (11010)₂ ke dalam sistem bilangan desimal adalah...",
    options: [
      "22",
      "24",
      "26",
      "28"
    ],
    correctAnswerIndex: 2,
    explanation: "(11010)₂ = (1×16) + (1×8) + (0×4) + (1×2) + (0×1) = 16 + 8 + 0 + 2 + 0 = (26)₁₀."
  },
  {
    id: "b6-q8",
    chapterId: 6,
    sectionCode: "B",
    sectionTitle: "Konversi Bilangan Biner & Operasi Aritmatika Digital (Numerasi)",
    text: "Hasil konversi bilangan biner (101101)₂ ke dalam sistem bilangan desimal adalah...",
    options: [
      "41",
      "43",
      "45",
      "47"
    ],
    correctAnswerIndex: 2,
    explanation: "(101101)₂ = (1×32) + (0×16) + (1×8) + (1×4) + (0×2) + (1×1) = 32 + 0 + 8 + 4 + 0 + 1 = (45)₁₀."
  },
  {
    id: "b6-q9",
    chapterId: 6,
    sectionCode: "B",
    sectionTitle: "Konversi Bilangan Biner & Operasi Aritmatika Digital (Numerasi)",
    text: "Bilangan desimal (25)₁₀ jika dikonversikan ke dalam bilangan biner dengan metode pembagian berulang menghasilkan...",
    options: [
      "(11001)₂",
      "(10011)₂",
      "(11010)₂",
      "(11100)₂"
    ],
    correctAnswerIndex: 0,
    explanation: "25 ÷ 2 = 12 sisa 1; 12 ÷ 2 = 6 sisa 0; 6 ÷ 2 = 3 sisa 0; 3 ÷ 2 = 1 sisa 1; 1 ÷ 2 = 0 sisa 1. Dibaca dari bawah ke atas: (11001)₂."
  },
  {
    id: "b6-q10",
    chapterId: 6,
    sectionCode: "B",
    sectionTitle: "Konversi Bilangan Biner & Operasi Aritmatika Digital (Numerasi)",
    text: "Bilangan desimal (50)₁₀ jika diubah ke dalam bentuk bilangan biner adalah...",
    options: [
      "(110010)₂",
      "(110100)₂",
      "(101100)₂",
      "(111010)₂"
    ],
    correctAnswerIndex: 0,
    explanation: "50 = 32 + 16 + 2 = (1×32) + (1×16) + (0×8) + (0×4) + (1×2) + (0×1) = (110010)₂."
  },
  {
    id: "b6-q11",
    chapterId: 6,
    sectionCode: "B",
    sectionTitle: "Konversi Bilangan Biner & Operasi Aritmatika Digital (Numerasi)",
    text: "Hasil penjumlahan aritmatika biner dari (1011)₂ + (0110)₂ adalah...",
    options: [
      "(10001)₂",
      "(10010)₂",
      "(11101)₂",
      "(10101)₂"
    ],
    correctAnswerIndex: 0,
    explanation: "1011₂ (11) + 0110₂ (6) = 17 desimal. Nilai 17 dalam biner = 16 + 1 = (10001)₂."
  },
  {
    id: "b6-q12",
    chapterId: 6,
    sectionCode: "B",
    sectionTitle: "Konversi Bilangan Biner & Operasi Aritmatika Digital (Numerasi)",
    text: "Bilangan biner 8-bit (11011010)₂ jika dikelompokkan per 4 bit dan dikonversikan ke dalam bilangan heksadesimal bernilai...",
    options: [
      "(DA)₁₆",
      "(DB)₁₆",
      "(CA)₁₆",
      "(AD)₁₆"
    ],
    correctAnswerIndex: 0,
    explanation: "1101₂ = 13 (D₁₆) dan 1010₂ = 10 (A₁₆). Maka hasil heksadesimalnya adalah (DA)₁₆."
  },
  {
    id: "b6-q13",
    chapterId: 6,
    sectionCode: "B",
    sectionTitle: "Konversi Bilangan Biner & Operasi Aritmatika Digital (Numerasi)",
    text: "Operasi logika bitwise AND antara bilangan biner (1100)₂ AND (1010)₂ menghasilkan...",
    options: [
      "(1000)₂",
      "(1110)₂",
      "(0110)₂",
      "(1100)₂"
    ],
    correctAnswerIndex: 0,
    explanation: "Bitwise AND menghasilkan 1 hanya jika kedua bit bernilai 1. Bit ke-4: 1 AND 1 = 1; Bit ke-3: 1 AND 0 = 0; Bit ke-2: 0 AND 1 = 0; Bit ke-1: 0 AND 0 = 0 → (1000)₂."
  },

  // Sub-Bab C: Logika Boolean, Gerbang Logika & Penalaran Komputasional (Numerasi)
  {
    id: "b6-q14",
    chapterId: 6,
    sectionCode: "C",
    sectionTitle: "Logika Boolean, Gerbang Logika & Penalaran Komputasional (Numerasi)",
    text: "Gerbang logika digital yang menghasilkan output bernilai 1 (TRUE) hanya jika SEMUA sinyal inputnya bernilai 1 adalah...",
    options: [
      "Gerbang OR",
      "Gerbang AND",
      "Gerbang NOT",
      "Gerbang XOR"
    ],
    correctAnswerIndex: 1,
    explanation: "Gerbang AND (konjungsi) mensyaratkan seluruh input bernilai 1 agar menghasilkan keluaran bernilai 1."
  },
  {
    id: "b6-q15",
    chapterId: 6,
    sectionCode: "C",
    sectionTitle: "Logika Boolean, Gerbang Logika & Penalaran Komputasional (Numerasi)",
    text: "Gerbang logika XOR (Exclusive OR) akan menghasilkan nilai output 1 (TRUE) apabila...",
    options: [
      "Kedua sinyal input bernilai sama-sama 1",
      "Kedua sinyal input bernilai sama-sama 0",
      "Kedua sinyal input memiliki nilai yang berbeda satu sama lain (satu bernilai 1 dan satu bernilai 0)",
      "Semua input terputus dari arus listrik"
    ],
    correctAnswerIndex: 2,
    explanation: "XOR (Exclusive OR) bernilai 1 jika nilai inputnya berbeda (0 XOR 1 = 1, 1 XOR 0 = 1; 0 XOR 0 = 0, 1 XOR 1 = 0)."
  },
  {
    id: "b6-q16",
    chapterId: 6,
    sectionCode: "C",
    sectionTitle: "Logika Boolean, Gerbang Logika & Penalaran Komputasional (Numerasi)",
    text: "Seorang siswa ingin mencari artikel ilmiah tentang 'kecerdasan buatan' yang hanya membahas bahasa pemrograman 'python' tetapi tidak ingin muncul bahasan mengenai 'robotika'. Sintaks pencarian boolean yang paling tepat adalah...",
    options: [
      "\"kecerdasan buatan\" python -robotika",
      "kecerdasan buatan OR python OR robotika",
      "kecerdasan buatan + robotika -python",
      "kecerdasan buatan NOT python"
    ],
    correctAnswerIndex: 0,
    explanation: "Tanda kutip \"...\" mengunci frasa persis, kata python menyertakan topik python, dan tanda minus (-robotika) mengecualikan hasil robotika."
  },
  {
    id: "b6-q17",
    chapterId: 6,
    sectionCode: "C",
    sectionTitle: "Logika Boolean, Gerbang Logika & Penalaran Komputasional (Numerasi)",
    text: "Koneksi internet sebuah sekolah memiliki kapasitas bandwidth 40 Mbps (Megabit per second). Berapakah kecepatan unduh maksimal riil dalam satuan MB/s (Megabyte per second)?",
    options: [
      "40 MB/s",
      "20 MB/s",
      "5 MB/s",
      "8 MB/s"
    ],
    correctAnswerIndex: 2,
    explanation: "Karena 1 Byte = 8 bit, maka kecepatan unduh riil = 40 Mbps ÷ 8 = 5 MB/s."
  },
  {
    id: "b6-q18",
    chapterId: 6,
    sectionCode: "C",
    sectionTitle: "Logika Boolean, Gerbang Logika & Penalaran Komputasional (Numerasi)",
    text: "Sebuah video materi pembelajaran informatika berukuran 600 MB diunduh dengan kecepatan stabil 10 MB/s. Waktu yang diperlukan hingga proses unduhan selesai adalah...",
    options: [
      "30 detik",
      "60 detik (1 menit)",
      "120 detik (2 menit)",
      "600 detik (10 menit)"
    ],
    correctAnswerIndex: 1,
    explanation: "Waktu unduh = Ukuran Berkas ÷ Kecepatan = 600 MB ÷ 10 MB/s = 60 detik (1 menit)."
  },
  {
    id: "b6-q19",
    chapterId: 6,
    sectionCode: "C",
    sectionTitle: "Logika Boolean, Gerbang Logika & Penalaran Komputasional (Numerasi)",
    text: "Sebuah harddisk eksternal berkapasitas 2 TB (Terabyte). Jika 1 TB setara dengan 1.024 GB, berapakah jumlah maksimal file video berukuran 4 GB yang dapat disimpan di dalam harddisk tersebut?",
    options: [
      "256 file",
      "512 file",
      "1.024 file",
      "2.048 file"
    ],
    correctAnswerIndex: 1,
    explanation: "Kapasitas = 2 × 1.024 GB = 2.048 GB. Jumlah file = 2.048 GB ÷ 4 GB = 512 file video."
  },

  // Sub-Bab D: Literasi Informasi, Evaluasi Teks Kritis & Cek Fakta Digital (Literasi)
  {
    id: "b6-q20",
    chapterId: 6,
    sectionCode: "D",
    sectionTitle: "Literasi Informasi, Evaluasi Teks Kritis & Cek Fakta Digital (Literasi)",
    text: "Metode CRAAP Test adalah kerangka kerja berpikir kritis untuk mengevaluasi kredibilitas sumber informasi digital. Huruf 'A' pertama dalam akronim CRAAP mewakili aspek...",
    options: [
      "Authority (Otoritas & keahlian lembaga/penulis penerbit)",
      "Application (Aplikasi yang digunakan)",
      "Algorithm (Algoritma pemeringkat web)",
      "Advertisement (Iklan yang terpasang)"
    ],
    correctAnswerIndex: 0,
    explanation: "CRAAP adalah singkatan dari Currency (Kemutakhiran), Relevance (Relevansi), Authority (Otoritas penulis), Accuracy (Akurasi data), dan Purpose (Tujuan pembuatan)."
  },
  {
    id: "b6-q21",
    chapterId: 6,
    sectionCode: "D",
    sectionTitle: "Literasi Informasi, Evaluasi Teks Kritis & Cek Fakta Digital (Literasi)",
    text: "Perbedaan mendasar antara Disinformasi dan Misinformasi dalam klasifikasi gangguan informasi digital (Information Disorder) terletak pada...",
    options: [
      "Niat dan kesengajaan untuk menipu atau merugikan pihak lain",
      "Jumlah karakter huruf dalam berita",
      "Format file dokumen yang digunakan",
      "Kecepatan transmisi jaringan internet"
    ],
    correctAnswerIndex: 0,
    explanation: "Misinformasi terjadi karena ketidaktahuan tanpa niat jahat, sedangkan Disinformasi sengaja dibuat dan disebarkan untuk memanipulasi atau merugikan publik."
  },
  {
    id: "b6-q22",
    chapterId: 6,
    sectionCode: "D",
    sectionTitle: "Literasi Informasi, Evaluasi Teks Kritis & Cek Fakta Digital (Literasi)",
    text: "Sebuah foto dramatis beredar di media sosial dengan klaim bencana alam terkini. Langkah verifikasi literasi digital paling efektif untuk memastikan keaslian konteks foto tersebut adalah...",
    options: [
      "Langsung membagikan foto ke grup kelas agar semua waspada",
      "Melakukan Pencarian Gambar Terbalik (Reverse Image Search) melalui mesin pencari gambar",
      "Mengubah filter warna foto agar tampak lebih tajam",
      "Menghapus aplikasi media sosial dari ponsel"
    ],
    correctAnswerIndex: 1,
    explanation: "Reverse Image Search (seperti di Google Images) dapat melacak sumber asli, tanggal pertama kali foto diunggah, dan peristiwa sebenarnya."
  },
  {
    id: "b6-q23",
    chapterId: 6,
    sectionCode: "D",
    sectionTitle: "Literasi Informasi, Evaluasi Teks Kritis & Cek Fakta Digital (Literasi)",
    text: "Ciri-ciri khas dari judul berita Clickbait (Umpan Klik) yang sering dijumpai pada situs informasi tidak berkualitas adalah...",
    options: [
      "Menggunakan judul bombastis, memancing penasaran berlebihan, huruf kapital masif, namun isinya tidak sesuai dengan klaim judul",
      "Menyertakan tautan referensi jurnal ilmiah dan nama penulis resmi",
      "Memuat data statistik dengan tabel dan grafik terverifikasi",
      "Menggunakan tata bahasa baku sesuai Pedoman Umum Ejaan Bahasa Indonesia (PUEBI)"
    ],
    correctAnswerIndex: 0,
    explanation: "Clickbait sengaja memanipulasi emosi dan rasa penasaran pembaca dengan judul berlebihan untuk meraup jumlah klik iklan."
  },
  {
    id: "b6-q24",
    chapterId: 6,
    sectionCode: "D",
    sectionTitle: "Literasi Informasi, Evaluasi Teks Kritis & Cek Fakta Digital (Literasi)",
    text: "Dalam diagram alir (Flowchart) algoritma komputasi, simbol berbentuk Belah Ketupat (Diamond) merepresentasikan...",
    options: [
      "Awal atau akhir program (Terminator)",
      "Proses komputasi atau perhitungan aritmatika",
      "Keputusan / Percabangan Logika (Decision: Ya / Tidak)",
      "Operasi Input / Output data"
    ],
    correctAnswerIndex: 2,
    explanation: "Simbol Belah Ketupat (Decision) digunakan untuk menguji kondisi logika (percabangan If-Then) dengan dua atau lebih jalur keluaran."
  },
  {
    id: "b6-q25",
    chapterId: 6,
    sectionCode: "D",
    sectionTitle: "Literasi Informasi, Evaluasi Teks Kritis & Cek Fakta Digital (Literasi)",
    text: "Informasi yang berbasis fakta riil namun dipublikasikan ke publik secara tidak etis dengan maksud sengaja untuk mempermalukan atau merusak reputasi seseorang dinamakan...",
    options: [
      "Malinformasi",
      "Disinformasi",
      "Misinformasi",
      "Enkripsi Informasi"
    ],
    correctAnswerIndex: 0,
    explanation: "Malinformasi menggunakan informasi asli (fakta) tetapi disebarkan di luar konteks atau secara ilegal dengan niat jahat untuk merusak reputasi target."
  },

  // Sub-Bab E: Etika Komunikasi Digital (Netiket), Hak Cipta & Jejak Digital (Literasi)
  {
    id: "b6-q26",
    chapterId: 6,
    sectionCode: "E",
    sectionTitle: "Etika Komunikasi Digital (Netiket), Hak Cipta & Jejak Digital (Literasi)",
    text: "Dalam etika berkomunikasi di dunia maya (Netiket), mengetik pesan obrolan atau surat elektronik dengan menggunakan HURUF KAPITAL SELURUHNYA ditafsirkan sebagai...",
    options: [
      "Ungkapan penuh rasa hormat dan kesopanan",
      "Ekspresi berteriak, marah, atau bernada membentak lawan bicara",
      "Penanda bahwa pesan tersebut bersifat rahasia negara",
      "Cara baku untuk mempercepat proses pengiriman pesan"
    ],
    correctAnswerIndex: 1,
    explanation: "Dalam konvensi netiket internasional (ALL CAPS), huruf besar seluruhnya dianggap setara dengan berteriak dan tidak sopan."
  },
  {
    id: "b6-q27",
    chapterId: 6,
    sectionCode: "E",
    sectionTitle: "Etika Komunikasi Digital (Netiket), Hak Cipta & Jejak Digital (Literasi)",
    text: "Lisensi Creative Commons bertipe 'CC BY' (Attribution) memberikan izin kepada pengguna lain untuk...",
    options: [
      "Menggunakan, membagikan, dan memodifikasi karya asalkan mencantumkan atribusi/kredit kepada pencipta aslinya",
      "Menjual karya orang lain tanpa perlu menyebutkan nama penciptanya",
      "Mengklaim karya tersebut sebagai ciptaan pribadi",
      "Mengunci kode sumber karya agar tidak bisa dilihat publik"
    ],
    correctAnswerIndex: 0,
    explanation: "Lisensi CC BY (Attribution) membebaskan penggandaan dan adaptasi karya dengan syarat wajib memberikan kredit kepada pencipta."
  },
  {
    id: "b6-q28",
    chapterId: 6,
    sectionCode: "E",
    sectionTitle: "Etika Komunikasi Digital (Netiket), Hak Cipta & Jejak Digital (Literasi)",
    text: "Contoh dari Jejak Digital Pasif (Passive Digital Footprint) yang ditinggalkan oleh pengguna internet tanpa disadari secara aktif adalah...",
    options: [
      "Mengunggah foto liburan ke feed Instagram",
      "Menulis komentar pada video YouTube",
      "Alamat IP perangkat, data lokasi GPS, dan riwayat penelusuran situs yang terekam oleh web server/cookies",
      "Mengirimkan formulir pendaftaran tugas daring"
    ],
    correctAnswerIndex: 2,
    explanation: "Jejak pasif terekam otomatis di latar belakang oleh sistem komputer (alamat IP, cookies, metadata jaringan) tanpa aksi posting sadar pengguna."
  },
  {
    id: "b6-q29",
    chapterId: 6,
    sectionCode: "E",
    sectionTitle: "Etika Komunikasi Digital (Netiket), Hak Cipta & Jejak Digital (Literasi)",
    text: "Mengapa pemahaman mengenai Jejak Digital (Digital Footprint) sangat penting bagi seorang pelajar di era modern?",
    options: [
      "Karena jejak digital bersifat permanen dan dapat memengaruhi reputasi personal, seleksi perguruan tinggi, serta peluang karier masa depan",
      "Karena jejak digital dapat mempercepat kecepatan internet di rumah",
      "Agar kuota internet yang digunakan tidak cepat habis",
      "Supaya akun media sosial langsung mendapatkan centang biru verifikasi"
    ],
    correctAnswerIndex: 0,
    explanation: "Jejak digital sulit dihapus secara permanen dan kini menjadi salah satu parameter penilaian integritas serta reputasi oleh institusi pendidikan dan dunia kerja."
  },
  {
    id: "b6-q30",
    chapterId: 6,
    sectionCode: "E",
    sectionTitle: "Etika Komunikasi Digital (Netiket), Hak Cipta & Jejak Digital (Literasi)",
    text: "Praktik menyebarluaskan data pribadi rahasia seseorang (seperti alamat rumah, nomor identitas, atau nomor telepon pribadi) ke media sosial tanpa izin dengan tujuan mengintimidasi dinamakan...",
    options: [
      "Doxing",
      "Phishing",
      "Defragmentasi",
      "Kompresi Data"
    ],
    correctAnswerIndex: 0,
    explanation: "Doxing (Drop Docs) adalah tindakan berbahaya mempublikasikan informasi identitas pribadi seseorang secara daring tanpa izin untuk memicu perundungan siber."
  }
];
